(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[722],{

/***/ 8557:
/***/ (function(module) {

module.exports = "/_next/static/videos/01-video-492cbb572a41bf6fc2be6a35d7e7b2e2.mp4";

/***/ }),

/***/ 8114:
/***/ (function(module) {

module.exports = "/_next/static/videos/02-video-39230a4907cc265c280707a3c422c233.mp4";

/***/ }),

/***/ 5189:
/***/ (function(module) {

module.exports = "/_next/static/videos/03-video-96d6cf2172022f84ec4977e1dba76bff.mp4";

/***/ }),

/***/ 4456:
/***/ (function(module) {

module.exports = "/_next/static/videos/01-video-262fd3558f02d49f91a64a2576c22662.mp4";

/***/ }),

/***/ 3045:
/***/ (function(module) {

module.exports = "/_next/static/videos/02-video-d2a046a04121b224d12318d6e45f6f45.mp4";

/***/ }),

/***/ 2401:
/***/ (function(module) {

module.exports = "/_next/static/videos/01-video-7a6b55037f3f61bb652b15fa8d62e59b.mp4";

/***/ }),

/***/ 434:
/***/ (function(module) {

module.exports = "/_next/static/videos/02-video-ddd19f6c4115769a9c8ce2b984b47eb7.mp4";

/***/ }),

/***/ 7357:
/***/ (function(module) {

module.exports = "/_next/static/videos/video-s-8a567bd44173dac4a911eb3483563e07.mp4";

/***/ }),

/***/ 545:
/***/ (function(module) {

module.exports = "/_next/static/videos/video-xl-eee8c9174ea1395876381d7d7dc2c0a9.mp4";

/***/ }),

/***/ 4564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[p_name]",
      function () {
        return __webpack_require__(797);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9938:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/a.cc1f7625.png","height":768,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAKlBMVEWCiYOOlo1hameMiYB2f35gYWSZpJuqq5avsaGJiW+BdFlCU2WBfkrKyaffrJL1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nCXExw0AIAwEwT0HTOy/XYSYxxA80l8SzXMFzeceRK9TpDtglmYXCvsAkNZFaVYAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 2332:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/b.3adc7de2.jpg","height":768,"width":512,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAL/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQISAwQycf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AueTDN2WzrqD5i7WXoABL/9k=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 1804:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/d.86a3664a.png","height":768,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAANlBMVEWMlIyrq5hZYWKBd1F1fX2Wn5eEhICAiIOEioRgZ2SKiX18gn5jbmyPjIOIiG5CUWRpX2PIyaciQjiRAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAL0lEQVR4nBXBhxGAMAwAsXfimgr7L8shoZE5gYzA+Nl+rmLe+0FFXqGN4U6tVvUBFeAA+fH5eyoAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});

/***/ }),

/***/ 1924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Global_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6402);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5378);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .io-target {\n    position: absolute;\n    top: 0;\n    height: 60px;\n    width: 100%;\n    z-index: -1;\n  }\n  position: fixed;\n  z-index: 99;\n  bottom: 56px;\n  text-align: right;\n  right: 32px;\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    bottom: 32px;\n    right: 32px;\n  }\n  @media screen and (max-width: 599px) {\n    bottom: 32px;\n    right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FloatingController = function(param) {
    var isVisible = param.isVisible;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var handleClickScrollBtn = function() {
        if (!isVisible) (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_4__/* .scrollTo */ .X5)(window, {
            top: 0,
            behavior: "smooth"
        });
        else {
            var $aboutMainBanner = document.querySelector(".main-section-container");
            if ($aboutMainBanner) {
                var scrollValue = $aboutMainBanner.getBoundingClientRect().height;
                (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_4__/* .scrollTo */ .X5)(window, {
                    top: scrollValue,
                    behavior: "smooth"
                });
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FloatingControllerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ScrollButton */ .xE, {
                isOpenContact: false,
                isScrolled: !isVisible,
                onClick: handleClickScrollBtn
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ContactButton */ .AI, {
                onClick: function() {
                    return push("/contact");
                }
            })
        ]
    });
};
var FloatingControllerContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FloatingController__FloatingControllerContainer",
    componentId: "sc-9575fc0c-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (FloatingController);


/***/ }),

/***/ 9766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var global_styles_MainButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8920);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1089);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9059);
/* harmony import */ var hooks_useContactModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2921);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding: 103.5px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n  text-align: center;\n  color: #fff;\n\n  @media screen and (max-width: 1239px) {\n    padding: 56px 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ProductContactUs = function(param) {
    var locale = param.locale;
    var handleMoveToContactUsPage = (0,hooks_useContactModal__WEBPACK_IMPORTED_MODULE_5__/* .useContactModal */ .s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ProductContactUsContainer, {
        children: [
            locale === "en" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__.H2, {
                        as: "p",
                        children: "Inquiry For more information,"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__.H2, {
                        as: "p",
                        children: "please contact us."
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .H2KR */ .Zj, {
                        as: "p",
                        children: "제품\xb7기술과 관련된"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_4__/* .H2KR */ .Zj, {
                        as: "p",
                        children: "궁금한 점이 있으시면 문의를 남겨주세요."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles_MainButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                buttonType: "default-w",
                text: locale === "en" ? "Contact Us" : "문의하러 가기",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_3__/* .ReceiverIcon */ .dt, {}),
                iconPosition: "left",
                style: {
                    marginTop: "32px",
                    width: "328px",
                    height: "48px"
                },
                onClick: handleMoveToContactUsPage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductContactUs);
var ProductContactUsContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "ProductContactUs__ProductContactUsContainer",
    componentId: "sc-f197cf3a-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_4__/* .BBINDIGO */ ._4);


/***/ }),

/***/ 1875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ AVIFHeadTextComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9059);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  padding: 32px 0 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var AVIFHeadTextComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(global_styles__WEBPACK_IMPORTED_MODULE_1__/* .AVIFHeadText */ .cf).withConfig({
    displayName: "AVIFCommonComponents__AVIFHeadTextComponent",
    componentId: "sc-4646caf5-0"
})(_templateObject());


/***/ }),

/***/ 4233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5564);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #f2f2f2;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 12px;\n  width: 100%;\n  & + & {\n    margin-left: 18px;\n  }\n\n  .top-area {\n    width: 100%;\n    padding-top: ",
        ";\n    position: relative;\n  }\n  .bottom-area {\n    padding: 8px;\n  }\n\n  .o-c-w {\n    font-weight: 500;\n  }\n  .s-c-w {\n    font-weight: 700;\n  }\n  .upper-w {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n  .below-w {\n    margin-top: 12px;\n    font-weight: 500;\n  }\n\n  @media screen and (max-width: 904px) {\n    margin: 16px 0;\n  }\n\n  @media screen and (max-width: 904px) {\n    margin: 8px 0;\n    & + & {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AVIFSpeedQualityTestImageArea = function(param) {
    var src = param.src, imgOgCompText = param.imgOgCompText, sizeAndContainerText = param.sizeAndContainerText, _scoreText = param.scoreText, scoreText = _scoreText === void 0 ? "" : _scoreText, paddingTopPercentage = param.paddingTopPercentage, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AVIFSpeedQualityTestImageAreaContainer, {
        paddingTopPercentage: paddingTopPercentage,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "top-area",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Common_CommonWrappers__WEBPACK_IMPORTED_MODULE_2__/* .ImgBackgroundWrapper */ .Yo, {
                    isNormalUse: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: src,
                        alt: "",
                        objectFit: "cover",
                        layout: "fill",
                        priority: priority
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bottom-area",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "upper-w",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "o-c-w",
                                children: imgOgCompText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "s-c-w",
                                children: sizeAndContainerText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "below-w",
                        children: scoreText
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AVIFSpeedQualityTestImageArea);
var AVIFSpeedQualityTestImageAreaContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AVIFSpeedQualityTestImageArea__AVIFSpeedQualityTestImageAreaContainer",
    componentId: "sc-aa888a9-0"
})(_templateObject(), function(param) {
    var paddingTopPercentage = param.paddingTopPercentage;
    return paddingTopPercentage;
});


/***/ }),

/***/ 1222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AVIFSpeedQualityImgs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5505);
/* harmony import */ var _AVIFCommonComponents__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1875);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1089);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9059);
/* harmony import */ var _AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4233);
/* harmony import */ var public_asset_product_pulsar_05_AVIF_yacht_a_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9938);
/* harmony import */ var public_asset_product_pulsar_05_AVIF_yacht_b_jpg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2332);
/* harmony import */ var public_asset_product_pulsar_05_AVIF_yacht_d_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1804);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_10__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: 48px;\n  .read-more-link {\n    display: flex;\n    height: 64px;\n    background: #f2f2f2;\n    align-items: center;\n    margin-top: 24px;\n    border-radius: 9999px;\n    font-family: 'Noto Sans KR', sans-serif;\n    font-size: 17px;\n    font-weight: 700;\n    color: ",
        ";\n    padding-left: 32px;\n  }\n  .read-more-link:hover .svg-t {\n    text-decoration: underline;\n  }\n  .svg-t,\n  .svg-w,\n  .svg-g-t {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .svg-w {\n    width: 76px;\n    height: 32px;\n    transform: rotate(180deg);\n  }\n  .svg-g-t {\n    width: 66px;\n    height: 30px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  padding: 12px;\n  @media screen and (max-width: 904px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var AvifSQTestCondition = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AvifSQTestConditionContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFCommonComponents__WEBPACK_IMPORTED_MODULE_3__/* .AVIFHeadTextComponent */ ._, {
                children: "AVIF Speed/Quality Benchmark"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AVIFSpeedQualityImgs, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_10___default()), {
                href: "/avif-speed-quality-benchmark",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                    className: "read-more-link",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "svg-t",
                            children: "Read more in details"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: "svg-g-t",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(assets_icons__WEBPACK_IMPORTED_MODULE_4__/* .GoToIcon */ .A5, {
                                size: "18"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvifSQTestCondition);
var AvifSQTestConditionContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AvifSQTestCondition__AvifSQTestConditionContainer",
    componentId: "sc-5d74bc16-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_5__.BB);
var AVIFSpeedQualityImgs = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AVIFSpeedQualityImgsContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: public_asset_product_pulsar_05_AVIF_yacht_a_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"].src */ .Z.src,
                imgOgCompText: "(a) original",
                sizeAndContainerText: "PNG / 582.9kb",
                paddingTopPercentage: "150%",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: public_asset_product_pulsar_05_AVIF_yacht_b_jpg__WEBPACK_IMPORTED_MODULE_8__/* ["default"].src */ .Z.src,
                imgOgCompText: "(b) compressed",
                sizeAndContainerText: "jpeg / 16.2kb",
                scoreText: "psnr=34.19, ssim=0.914, vmaf=81.4",
                paddingTopPercentage: "150%",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AVIFSpeedQualityTestImageArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                src: public_asset_product_pulsar_05_AVIF_yacht_d_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"].src */ .Z.src,
                imgOgCompText: "(d) compressed",
                sizeAndContainerText: "pulsar avif / 7.1kb",
                scoreText: "psnr=35.49, ssim=0.927, vmaf=77.6",
                paddingTopPercentage: "150%",
                priority: true
            })
        ]
    });
};
var AVIFSpeedQualityImgsContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AvifSQTestCondition__AVIFSpeedQualityImgsContainer",
    componentId: "sc-5d74bc16-1"
})(_templateObject1());


/***/ }),

/***/ 5305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useDisablePinchZoom; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useDisablePinchZoom = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleDisablePinchZoom = function(e) {
            if (e.touches.length > 1 || e.targetTouches.length > 1) {
                e.preventDefault();
            }
        };
        var handleDisablePinchZoomSafari = function(e) {
            return e.preventDefault();
        };
        window.addEventListener("touchstart", handleDisablePinchZoom);
        document.documentElement.addEventListener("touchstart", handleDisablePinchZoom);
        document.addEventListener("gesturestart", handleDisablePinchZoomSafari);
    }, []);
};


/***/ }),

/***/ 8722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useRemoveScrollTop; }
/* harmony export */ });
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useRemoveScrollTop = function() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_0__/* .useBlogContext */ .F)().dispatch;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!asPath.includes("blog")) {
            dispatch({
                type: "change",
                newState: {
                    prevScrollTop: 0
                }
            });
        }
    }, [
        asPath,
        dispatch
    ]);
};


/***/ }),

/***/ 4772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useSetScreenSize; }
/* harmony export */ });
/* unused harmony export setScreenSize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var setScreenSize = function() {
    var vh = (window.innerHeight > 640 ? window.innerHeight : 640) * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};
var useSetScreenSize = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setScreenSize();
        window.addEventListener("resize", setScreenSize);
        window.addEventListener("orientationchange", setScreenSize);
        return function() {
            window.removeEventListener("resize", setScreenSize);
            window.removeEventListener("orientationchange", setScreenSize);
        };
    }, []);
};


/***/ }),

/***/ 797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _p_name_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./components/NewHeader/index.tsx + 11 modules
var NewHeader = __webpack_require__(1849);
// EXTERNAL MODULE: ./components/Common/FloatingController.tsx
var FloatingController = __webpack_require__(1924);
// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ./components/Global/index.ts + 16 modules
var Global = __webpack_require__(6402);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ./public/asset/product/deepfield/00-main-visual/product-main-bg@2x.png
/* harmony default export */ var product_main_bg_2x = ({"src":"/_next/static/media/product-main-bg@2x.288fa38a.png","height":1620,"width":2880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEUCDCUCEDASNn0jPG0cUZ5GgM8lRnoXQYo4XJwZR5cQKFwOLGxCfMgVHzZCVHPL8ld0AAAACXBIWXMAAC4jAAAuIwF4pT92AAAALElEQVR4nB3KtxEAIAwAsXcETNh/XA5UCxEQAFPX0exgfUX02mTzobPyh9cuDkcAqgakNcUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
;// CONCATENATED MODULE: ./components/Common/BlueLabelBox.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 389px;\n  min-height: 100px;\n  background: #fff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 16px;\n  overflow: hidden;\n  transition: transform 0.35s cubic-bezier(0.1, 0.57, 0.1, 1);\n  &::before {\n    content: '';\n    height: 8px;\n    background: #2564ce;\n    width: 100%;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      transform: translate3d(0, -10px, 0);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function BlueLabelBox(_param) {
    var tag = _param.tag, className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "tag",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueLabelBoxContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        as: tag
    }, rest), {
        children: children
    }));
}
var BlueLabelBoxContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BlueLabelBox__BlueLabelBoxContainer",
    componentId: "sc-e22ff652-0"
})(_templateObject());

// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ./components/Home/BannerItems.tsx
var BannerItems = __webpack_require__(2486);
;// CONCATENATED MODULE: ./components/Product/DeepfieldMainVisual.tsx

function DeepfieldMainVisual_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .box-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 56px;\n    animation: ",
        " 1.5s 1.6s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n  }\n  .product-main-box + .product-main-box {\n    margin: 0 0 0 16px;\n  }\n  .ko-wrapper-pc {\n    display: block;\n  }\n  .ko-wrapper-mo {\n    display: none;\n  }\n  @media screen and (max-width: 904px) {\n    .box-wrapper {\n      flex-direction: column;\n    }\n    .product-main-box + .product-main-box {\n      margin: 16px 0 0;\n    }\n  }\n\n  @media screen and (max-width: 599px) {\n    .ko-wrapper-pc {\n      display: none;\n    }\n    .ko-wrapper-mo {\n      display: block;\n    }\n  }\n"
    ]);
    DeepfieldMainVisual_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 599px) {\n    width: 328px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 18px 16px;\n  .top-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .product-name {\n    margin-left: 4px;\n    color: ",
        ";\n  }\n  .hash-list {\n    color: ",
        ";\n    display: flex;\n    justify-content: center;\n  }\n  .hash-list > li + li {\n    margin: 0 0 0 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var KO = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ko-wrapper-pc",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* SubtitleM */.sy, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "블루닷 제품으로 비용을 절감하며 화질을 개선하고"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "만족도 높은 시청경험을 제공해보세요."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ko-wrapper-mo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* SubtitleM */.sy, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "블루닷 제품으로 비용을 절감하며"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "화질을 개선하고"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "만족도 높은 시청경험을 제공해보세요."
                        })
                    ]
                })
            })
        ]
    });
};
var EN = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "en-wrapper-pc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "With BLUEDOT's product, you can reduce the cost,"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "improve video quality, and provide users"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "with a better viewing experience."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "en-wrapper-mo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "With BLUEDOT's product,"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "you can reduce the cost,"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "improve video quality, and provide users"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "with a better viewing experience."
                        })
                    })
                ]
            })
        ]
    });
};
var DeepfieldMainVisual = /*#__PURE__*/ (0,react.forwardRef)(function(_, ref) {
    var _$ref = (0,router.useRouter)(), locale = _$ref.locale, push = _$ref.push;
    var boxWrapperItems = (0,react.useMemo)(function() {
        return [
            {
                productName: "DeepField",
                hashListItemsKo: [
                    "#영상&이미지",
                    "#화질개선",
                    "#업스케일링"
                ],
                hashListItemsEn: [
                    "#video&image",
                    "#improvement",
                    "#upscaling"
                ],
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DeepfieldIcon */.kq, {}),
                onClick: function() {
                    return push({
                        pathname: "/product/sr",
                        hash: encodeURIComponent("product-section")
                    }, undefined, {
                        scroll: false
                    });
                }
            },
            {
                productName: "Pulsar",
                hashListItemsKo: [
                    "#영상&이미지",
                    "#인코딩",
                    "#비용절감"
                ],
                hashListItemsEn: [
                    "#video&image",
                    "#encoding",
                    "#reduced cost"
                ],
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PulsarIcon */.tD, {}),
                onClick: function() {
                    return push({
                        pathname: "/product/av1",
                        hash: "#product-section"
                    }, undefined, {
                        scroll: false
                    });
                }
            }, 
        ];
    }, [
        push
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeepfieldMainVisualContainer, {
        ref: ref,
        className: "main-section-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: product_main_bg_2x.src,
                    layout: "fill",
                    alt: "",
                    className: "target-img",
                    objectFit: "cover",
                    loading: "eager",
                    priority: true,
                    quality: 70,
                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 60vw, (max-width: 599px) 45vw"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonWrappers/* MainVisualInnerContainer */.rO, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H1, {
                        className: "main-typo",
                        as: "h2",
                        children: "Product"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc-text-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EN, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KO, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "box-wrapper",
                        children: boxWrapperItems.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBlueLabelBox, {
                                className: "product-main-box",
                                tag: "button",
                                onClick: item.onClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductSubAnchor, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "top-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextLStrong */.zY, {
                                                    className: "product-name",
                                                    children: item.productName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "hash-list",
                                            children: (locale === "en" ? item.hashListItemsEn : item.hashListItemsKo).map(function(hashItem) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                                                    as: "li",
                                                    children: hashItem
                                                }, hashItem);
                                            })
                                        })
                                    ]
                                })
                            }, item.productName);
                        })
                    })
                ]
            })
        ]
    });
});
DeepfieldMainVisual.displayName = "DeepfieldMainVisual";
/* harmony default export */ var Product_DeepfieldMainVisual = (/*#__PURE__*/(0,react.memo)(DeepfieldMainVisual));
var DeepfieldMainVisualContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* MainVisualOuterContainer */.XY).withConfig({
    displayName: "DeepfieldMainVisual__DeepfieldMainVisualContainer",
    componentId: "sc-18eb1de2-0"
})(DeepfieldMainVisual_templateObject(), BannerItems/* txtAnimation */.Xn);
var ProductBlueLabelBox = (0,styled_components_browser_esm/* default */.ZP)(BlueLabelBox).withConfig({
    displayName: "DeepfieldMainVisual__ProductBlueLabelBox",
    componentId: "sc-18eb1de2-1"
})(_templateObject1());
var ProductSubAnchor = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DeepfieldMainVisual__ProductSubAnchor",
    componentId: "sc-18eb1de2-2"
})(_templateObject2(), global_styles.BB, global_styles/* GRAY50 */.mu);

// EXTERNAL MODULE: ./hooks/useDisablePinchZoomIn.ts
var useDisablePinchZoomIn = __webpack_require__(5305);
// EXTERNAL MODULE: ./hooks/useSetScreenSize.tsx
var useSetScreenSize = __webpack_require__(4772);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(2587);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
// EXTERNAL MODULE: ./hooks/useContactModal.ts
var useContactModal = __webpack_require__(2921);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(299);
;// CONCATENATED MODULE: ./components/Product/ProductBanner.tsx


function ProductBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "width: 328px;"
    ]);
    ProductBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        .banner-title {\n          animation: ",
        " 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n          opacity: 1;\n        }\n        .banner-text {\n          animation: ",
        " 1s 0.3s cubic-bezier(0.4, 0, 0.2, 1)\n            backwards;\n          opacity: 1;\n        }\n        .p-b-btn {\n          animation: ",
        " 1s 0.8s cubic-bezier(0.4, 0, 0.2, 1)\n            backwards;\n          opacity: 1;\n        }\n      "
    ]);
    ProductBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1200px;\n  position: relative;\n  height: 380px;\n  color: #fff;\n\n  @media screen and (min-width: 1440px) {\n    width: 100%;\n    max-width: 1200px;\n    margin: 96px auto 0;\n  }\n  @media screen and (min-width: 1240px) and (max-width: 1439px) {\n    width: calc(100% - 192px);\n    margin: 96px 96px 0;\n  }\n  @media screen and (min-width: 905px) and (max-width: 1239px) {\n    width: calc(100% - 112px);\n    margin: 96px 56px 0;\n  }\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    margin: 56px 0 0;\n  }\n  @media screen and (max-width: 599px) {\n    margin: 32px 0 0;\n  }\n  .banner-inner-wrapper {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0 56px;\n    word-break: break-word;\n    .banner-text {\n      width: 48ch;\n      opacity: 0;\n    }\n    .banner-title {\n      opacity: 0;\n    }\n    .p-b-btn {\n      opacity: 0;\n    }\n    ",
        ";\n    @media screen and (max-width: 904px) {\n      padding: 0 32px;\n      .banner-more-btn {\n        width: 156px;\n      }\n    }\n    @media screen and (max-width: 599px) {\n      .banner-text {\n        max-width: 35ch;\n      }\n    }\n  }\n"
    ]);
    ProductBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var ProductBanner = function(param) {
    var bannerImg = param.bannerImg, bannerText = param.bannerText, bannerTitle = param.bannerTitle, buttonText = param.buttonText;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    var handleMoveToContactUsPage = (0,useContactModal/* useContactModal */.s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductBannerContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: bannerImg,
                    layout: "fill",
                    className: "target-img",
                    objectFit: "cover",
                    loading: "eager",
                    quality: 55,
                    priority: true,
                    alt: "",
                    sizes: "(min-width: 1400px) 1200px, (min-width: 905px) calc(100vw - 60px), (min-width: 600px) 580px, (max-width: 599px) 400px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "banner-inner-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H3, {
                        className: "banner-title",
                        children: bannerTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        className: "banner-text",
                        children: bannerText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                        className: "p-b-btn",
                        onClick: handleMoveToContactUsPage,
                        buttonType: "default-w",
                        text: buttonText,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* NormalArrowIcon */.LS, {}),
                        injectInlineStyles: {
                            height: "48px",
                            marginTop: "32px"
                        },
                        injectCssStyles: [
                            (0,breakPoints/* generateCssStyle */.m)({
                                width: "156px"
                            }),
                            breakPoints/* mediaQueryStyle.M */.Pm.M(ProductBanner_templateObject()), 
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Product_ProductBanner = (ProductBanner);
var ProductBannerContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ProductBanner__ProductBannerContainer",
    componentId: "sc-dd58db95-0"
})(ProductBanner_templateObject2(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(ProductBanner_templateObject1(), BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn);
});

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Product/ProductTabMenu.tsx

function ProductTabMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          position: fixed;\n          width: 100vw !important;\n          margin: 0 !important;\n          top: 72px;\n          &::after {\n            transform: scaleX(1);\n          }\n          .tab-inner-wrapper::after {\n            width: 100vw !important;\n          }\n          @media screen and (min-width: 905px) {\n            top: 60px;\n          }\n          @media screen and (max-width: 904px) and (min-width: 600px) {\n            top: 52px;\n          }\n          @media screen and (max-width: 599px) {\n            top: 44px;\n          }\n        "
    ]);
    ProductTabMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductTabMenu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          position: 'static';\n          top: 'unset';\n        "
    ]);
    ProductTabMenu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductTabMenu_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  height: 62px;\n  position: relative;\n  z-index: 10;\n  background-color: #fff;\n  .tab-inner-wrapper {\n    height: 100%;\n    max-width: 1200px;\n    display: flex;\n    transition: top 0.25s cubic-bezier(0.1, 0.57, 0.1, 1);\n    position: relative;\n    z-index: 100;\n    background-color: transparent;\n\n    /* remove scrollbar */\n    overflow-x: scroll;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1200px;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n    }\n    @media screen and (max-width: 904px) and (min-width: 600px) {\n      width: 100%;\n    }\n    @media screen and (max-width: 599px) {\n      width: 100%;\n    }\n  }\n  .tab-inner-wrapper::after {\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    min-width: 480px;\n    content: '';\n    display: block;\n    background: ",
        ";\n    bottom: 0px;\n  }\n  &::after {\n    transform: scaleX(0);\n    transition: 0.2s transform cubic-bezier(0.1, 0.57, 0.1, 1);\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    min-width: 480px;\n    content: '';\n    display: block;\n    background: ",
        ";\n    bottom: 0px;\n  }\n  ",
        "\n"
    ]);
    ProductTabMenu_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 160px;\n  height: 60px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  & > a {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    white-space: nowrap;\n    transition: all 0.3s ease-in-out;\n    color: ",
        " !important;\n  }\n  @media (hover: hover) {\n    &:hover::after {\n      transform: scaleX(1);\n    }\n  }\n\n  &::after {\n    transition: transform 0.3s ease-in-out;\n    transform: ",
        ";\n    display: block;\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    height: 2px;\n    width: 160px;\n    background: #2564ce;\n    transform-origin: center;\n    z-index: 9999;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var ProductTabMenu = function(param) {
    var isFloatTab = param.isFloatTab, tabItems = param.tabItems;
    var asPath = (0,router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabMenuContainer, {
        isFloatTab: isFloatTab,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "tab-inner-wrapper",
            children: tabItems.map(function(tab) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HashTabItem, {
                    isSelected: asPath.toLowerCase().includes(tab.pathname),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: tab.pathname,
                            hash: "product-section"
                        },
                        scroll: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* ButtonText2 */.zg, {
                            as: "a",
                            children: tab.label
                        })
                    })
                }, tab.label);
            })
        })
    });
};
/* harmony default export */ var Product_ProductTabMenu = (ProductTabMenu);
var ProductTabMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ProductTabMenu__ProductTabMenuContainer",
    componentId: "sc-7279cc40-0"
})(ProductTabMenu_templateObject2(), global_styles/* GRAY80 */.OD, global_styles/* GRAY80 */.OD, function(param) {
    var isFloatTab = param.isFloatTab;
    return isFloatTab ? (0,styled_components_browser_esm/* css */.iv)(ProductTabMenu_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(ProductTabMenu_templateObject1());
});
var HashTabItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "ProductTabMenu__HashTabItem",
    componentId: "sc-7279cc40-1"
})(_templateObject3(), function(param) {
    var isSelected = param.isSelected;
    return isSelected ? global_styles.BB : global_styles/* GRAY30 */.zm;
}, function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "scaleX(1)" : "scaleX(0)";
});

;// CONCATENATED MODULE: ./components/Product/ProductDescription.tsx


function ProductDescription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .h3-kr-pd {\n        animation: ",
        " 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n        opacity: 1;\n      }\n      .b-t-pd {\n        animation: ",
        " 1s 0.3s cubic-bezier(0.4, 0, 0.2, 1)\n          backwards;\n        opacity: 1;\n      }\n      .desc-buttons-wrapper {\n        animation: ",
        " 1s 0.6s cubic-bezier(0.4, 0, 0.2, 1)\n          backwards;\n        opacity: 1;\n      }\n      .right-wrapper {\n        opacity: 1;\n      }\n    "
    ]);
    ProductDescription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductDescription_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  /* margin: 146px 0; */\n  margin: 146px 0 96px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  .left-wrapper {\n    padding-right: 96px;\n  }\n  .desc-title-wrapper {\n    padding: 32px 0;\n  }\n  .h3-kr-pd {\n    opacity: 0;\n  }\n  .b-t-pd {\n    color: ",
        ";\n    opacity: 0;\n  }\n  .b-t-pd + .b-t-pd {\n    margin-top: 32px;\n  }\n  .left-wrapper,\n  .right-wrapper {\n    width: 50%;\n    flex-shrink: 0;\n    position: relative;\n    max-width: 600px;\n  }\n  .right-wrapper {\n    height: 600px;\n    opacity: 0;\n    transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  .desc-buttons-wrapper {\n    display: flex;\n    margin-top: 56px;\n    opacity: 0;\n  }\n  .desc-buttons-wrapper > * + * {\n    margin-left: 16px;\n  }\n  ",
        ";\n  @media screen and (max-width: 1239px) and (min-width: 905px) {\n    .left-wrapper {\n      padding-right: 32px;\n    }\n  }\n\n  @media screen and (max-width: 904px) {\n    max-height: unset;\n    margin: 96px 0 56px;\n    flex-direction: column-reverse;\n    .left-wrapper {\n      max-width: 100%;\n      height: calc(100% - 320px);\n      width: 100%;\n      padding-right: 0;\n    }\n    .right-wrapper {\n      max-width: 100%;\n      height: 320px;\n      width: 100%;\n    }\n  }\n\n  @media screen and (max-width: 599px) {\n    margin: 56px 0 32px;\n  }\n"
    ]);
    ProductDescription_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ProductDescription = function(param) {
    var img = param.img, descriptionTitle = param.descriptionTitle, descriptions = param.descriptions, buttons = param.buttons;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDescriptionContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc-title-wrapper",
                        children: descriptionTitle.map(function(title) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: locale === "ko" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H3KR */.nX, {
                                    className: "h3-kr-pd",
                                    children: title
                                }, title) : /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H3, {
                                    className: "h3-kr-pd",
                                    children: title
                                }, title)
                            }, title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "descriptions-wrapper",
                        children: descriptions.map(function(desc) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextL */.q6, {
                                className: "b-t-pd",
                                children: desc
                            }, desc);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc-buttons-wrapper",
                        children: buttons
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                    isNormalUse: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: img,
                        layout: "fill",
                        alt: "",
                        className: "target-img",
                        objectFit: "cover",
                        sizes: "(min-width: 906px) 600px, (min-width: 600px) 95vw, (max-width: 599px) 95vw",
                        quality: 70,
                        loading: "eager",
                        priority: true
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Product_ProductDescription = (ProductDescription);
var ProductDescriptionContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ProductDescription__ProductDescriptionContainer",
    componentId: "sc-9ea5f51d-0"
})(ProductDescription_templateObject1(), global_styles/* GRAY50 */.mu, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(ProductDescription_templateObject(), BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn);
});

// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(6627);
;// CONCATENATED MODULE: ./components/Product/ProductCommons.tsx

function ProductCommons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 24px;\n  & + & {\n    padding-top: 0;\n  }\n"
    ]);
    ProductCommons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductCommons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 24px;\n  & + & {\n    padding-top: 0;\n  }\n"
    ]);
    ProductCommons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ProductCommonTitleEn = (0,styled_components_browser_esm/* default */.ZP)(global_styles.H3).withConfig({
    displayName: "ProductCommons__ProductCommonTitleEn",
    componentId: "sc-37e24852-0"
})(ProductCommons_templateObject());
var ProductCommonTitleKR = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* H3KR */.nX).withConfig({
    displayName: "ProductCommons__ProductCommonTitleKR",
    componentId: "sc-37e24852-1"
})(ProductCommons_templateObject1());

;// CONCATENATED MODULE: ./components/Product/Atoms/Feature/ItemTitle.tsx

function ItemTitle_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: 16px;\n"
    ]);
    ItemTitle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ItemTitle = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* SubtitleM */.sy).withConfig({
    displayName: "ItemTitle",
    componentId: "sc-1c91659c-0"
})(ItemTitle_templateObject(), global_styles/* GRAY30 */.zm);

;// CONCATENATED MODULE: ./components/Product/Atoms/Feature/ItemDescription.tsx

function ItemDescription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    ItemDescription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ItemDescription = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* BodyTextL */.q6).withConfig({
    displayName: "ItemDescription",
    componentId: "sc-58b887db-0"
})(ItemDescription_templateObject(), global_styles/* GRAY50 */.mu);

;// CONCATENATED MODULE: ./components/Product/Atoms/Feature/ItemVideoWrapper.tsx

function ItemVideoWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 328px;\n"
    ]);
    ItemVideoWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ItemVideoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemVideoWrapper",
    componentId: "sc-259643ef-0"
})(ItemVideoWrapper_templateObject());

;// CONCATENATED MODULE: ./components/Product/Atoms/Feature/index.ts




// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5680);
;// CONCATENATED MODULE: ./hooks/index.ts





var useAutoPlayVideoWhenVisible = function() {
    var videoRef = (0,react.useRef)(null);
    var cb = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_, entry) {
            var e, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!videoRef.current || !(entry === null || entry === void 0 ? void 0 : entry.target)) return [
                            2
                        ];
                        if (!entry.isIntersecting) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            videoRef.current.play()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            8
                        ];
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            videoRef.current.pause()
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        e1 = _state.sent();
                        console.log(e1);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_, entry) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        videoRef.current
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0.5,
        fallbackInView: true,
        onChange: cb
    }), 1), inviewRef = ref[0];
    var setRefs = (0,react.useCallback)(function(node) {
        videoRef.current = node;
        inviewRef(node);
    }, [
        inviewRef
    ]);
    return setRefs;
};

;// CONCATENATED MODULE: ./components/Product/Molcules/Feature/ItemVideoComponent.tsx

function ItemVideoComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & + & {\n    margin-top: 96px;\n  }\n\n  @media screen and (max-width: 904px) {\n    & + & {\n      margin-top: 56px;\n    }\n  }\n"
    ]);
    ItemVideoComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemVideoComponent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  & .item-wrapper {\n    margin-top: 8px;\n  }\n  & .item-desc {\n    margin-top: 8px;\n  }\n"
    ]);
    ItemVideoComponent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ItemVideoComponent = function(param) {
    var videoSrc = param.videoSrc, featureTitle = param.featureTitle, featureDescription = param.featureDescription;
    var setRefs = useAutoPlayVideoWhenVisible();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemVideoComponentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                children: featureTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemVideoWrapper, {
                className: "item-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: videoSrc,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    controls: true,
                    ref: setRefs
                })
            }),
            featureDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                className: "item-desc",
                children: featureDescription
            })
        ]
    });
};
var ItemCommonComponentContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ItemVideoComponent__ItemCommonComponentContainer",
    componentId: "sc-56b7f4e9-0"
})(ItemVideoComponent_templateObject());
var ItemVideoComponentContainer = (0,styled_components_browser_esm/* default */.ZP)(ItemCommonComponentContainer).withConfig({
    displayName: "ItemVideoComponent__ItemVideoComponentContainer",
    componentId: "sc-56b7f4e9-1"
})(ItemVideoComponent_templateObject1());

;// CONCATENATED MODULE: ./components/Product/Molcules/Feature/ItemImageComponent.tsx

function ItemImageComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        .imgs-wrapper:not(.art-d) .i-inner {\n          padding-top: 56.25%;\n        }\n        .imgs-wrapper {\n          flex-direction: column;\n        }\n        .i-inner + .i-inner {\n          margin-left: 0;\n          margin-top: 8px;\n        }\n      "
    ]);
    ItemImageComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemImageComponent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .imgs-wrapper {\n    display: flex;\n  }\n  .i-inner {\n    width: 100%;\n    position: relative;\n  }\n  .i {\n    width: 100%;\n  }\n  .i-inner + .i-inner {\n    margin-left: 8px;\n  }\n  .imgs-wrapper:not(.art-d) .i-inner {\n    padding-top: ",
        ";\n  }\n  .imgs-wrapper.art-d .i-inner {\n    height: 328px;\n  }\n  .item-desc {\n    margin-top: 8px;\n  }\n  .item-desc + .item-desc {\n    margin-top: 0px;\n  }\n  .desk {\n    display: block;\n  }\n  .mob {\n    display: none;\n  }\n  @media screen and (max-width: 904px) {\n    .desk {\n      display: none;\n    }\n    .mob {\n      display: block;\n    }\n    ",
        ";\n  }\n"
    ]);
    ItemImageComponent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ItemImageComponent = function(param) {
    var imageSrcArray = param.imageSrcArray, featureTitle = param.featureTitle, featureDescription = param.featureDescription, artDirection = param.artDirection, wrapMedia = param.wrapMedia;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemImageComponentContainer, {
        wrapMedia: wrapMedia,
        imgsLength: imageSrcArray.length,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                children: featureTitle
            }),
            artDirection ? // art direction
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "imgs-wrapper art-d",
                children: imageSrcArray.map(function(imgSrc, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: i === 0 ? "i-inner desk" : "i-inner mob",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "i",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                                isNormalUse: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: imgSrc,
                                    layout: "fill",
                                    alt: "",
                                    className: "target-img",
                                    objectFit: "cover",
                                    quality: 70,
                                    sizes: "(min-width: 906px) 95vw, (min-width: 600px) 80vw, (max-width: 599px) 75vw"
                                })
                            })
                        })
                    }, imgSrc);
                })
            }) : // art direction 아닌 경우
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "imgs-wrapper",
                children: imageSrcArray.map(function(imgSrc) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "i-inner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "i",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                                isNormalUse: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: imgSrc,
                                    layout: "fill",
                                    alt: "",
                                    className: "target-img",
                                    objectFit: "fill",
                                    quality: 70,
                                    sizes: "(min-width: 906px) 95vw, (min-width: 600px) 80vw, (max-width: 599px) 75vw"
                                })
                            })
                        })
                    }, imgSrc);
                })
            }),
            featureDescription.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: featureDescription.map(function(fd) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                        className: "item-desc",
                        children: fd
                    }, fd);
                })
            })
        ]
    });
};
var ItemImageComponentContainer = (0,styled_components_browser_esm/* default */.ZP)(ItemCommonComponentContainer).withConfig({
    displayName: "ItemImageComponent__ItemImageComponentContainer",
    componentId: "sc-2eb7f26-0"
})(ItemImageComponent_templateObject1(), function(param) {
    var imgsLength = param.imgsLength;
    return imgsLength === 0 ? "56.25%" : "calc(56.25% / ".concat(imgsLength, ")");
}, function(param) {
    var wrapMedia = param.wrapMedia;
    return wrapMedia && (0,styled_components_browser_esm/* css */.iv)(ItemImageComponent_templateObject());
});

;// CONCATENATED MODULE: ./components/Product/Molcules/Feature/ItemCustomComponent.tsx

function ItemCustomComponent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .custom-wrapper,\n  .item-desc {\n    margin-top: 8px;\n  }\n"
    ]);
    ItemCustomComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ItemCustomComponent = function(param) {
    var featureTitle = param.featureTitle, featureDescription = param.featureDescription, CustomComponent = param.customComponent, locale = param.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemCustomComponentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                children: featureTitle
            }),
            CustomComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-wrapper",
                children: /*#__PURE__*/ (0,react.cloneElement)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomComponent, {}), {
                    locale: locale
                })
            }),
            featureDescription && featureDescription.length !== 0 && featureDescription.map(function(fd) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                    className: "item-desc",
                    children: fd
                }, fd);
            })
        ]
    });
};
/* harmony default export */ var Feature_ItemCustomComponent = (ItemCustomComponent);
var ItemCustomComponentContainer = (0,styled_components_browser_esm/* default */.ZP)(ItemCommonComponentContainer).withConfig({
    displayName: "ItemCustomComponent__ItemCustomComponentContainer",
    componentId: "sc-1a27de86-0"
})(ItemCustomComponent_templateObject());

;// CONCATENATED MODULE: ./components/Product/Molcules/Feature/AiModelSelection.tsx

function AiModelSelection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 146px 0 96px;\n  .select-desc {\n    color: ",
        ";\n    margin: 8px 0 32px;\n  }\n  .model-desc-text {\n    color: ",
        ";\n  }\n  .model-box-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 24px 20px;\n  }\n  .model-box {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  .model-box-dv {\n    margin: 0 24px;\n    width: 1px;\n    height: 88px;\n    background: ",
        ";\n  }\n  .m-name,\n  .m-name-c {\n    white-space: wrap;\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n  }\n  .m-name-c {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .m-name-t {\n    font-size: 17px;\n    margin-left: 8px;\n    color: ",
        ";\n  }\n  .m-name-c .m-name-t {\n    margin-left: 0;\n  }\n  .picto-img-wrapper {\n    flex-shrink: 0;\n    margin-right: 20px;\n    position: relative;\n    width: 88px;\n    height: 88px;\n    background: ",
        ";\n    border-radius: 50%;\n    padding: 14px;\n    align-self: flex-start;\n  }\n  .picto-img {\n    width: 100%;\n    height: 100%;\n  }\n  .picto-img-inner-wrapper {\n    position: relative;\n    width: 60px;\n    height: 60px;\n  }\n  @media screen and (max-width: 904px) {\n    padding: 146px 0 56px;\n    .model-box-wrapper {\n      flex-direction: column;\n      padding: 20px 16px;\n    }\n    .model-box-dv {\n      margin: 20px 0;\n      width: 100%;\n      height: 1px;\n    }\n    .picto-img-wrapper {\n      width: 80px;\n      height: 80px;\n    }\n    .picto-img-inner-wrapper {\n      width: 55px;\n      height: 55px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 146px 0 32px;\n    .m-name,\n    .m-name-c {\n      font-size: 17px;\n    }\n  }\n"
    ]);
    AiModelSelection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var AiModelSelection = function(param) {
    var locale = param.locale, aiModelSelection = param.aiModelSelection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AiModelSelectionContainer, {
        children: [
            locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H4, {
                children: "Choosing an artificial intelligence Model"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* H4KR */.bJ, {
                children: "인공지능 모델 선택"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextL */.q6, {
                className: "select-desc",
                children: aiModelSelection.briefText[locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "model-box-wrapper",
                children: aiModelSelection.modelItems.map(function(model, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "model-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "picto-img-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "picto-img-inner-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "picto-img",
                                                src: model.modelPictoImg,
                                                layout: "fill",
                                                alt: "About bluedot",
                                                objectFit: "cover",
                                                quality: 70
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "content-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* SubtitleM */.sy, {
                                                className: locale === "en" ? "m-name-c" : "m-name",
                                                children: [
                                                    model.modelName[locale][0],
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "m-name-t",
                                                        children: model.modelName[locale][1]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextM */.OV, {
                                                className: "model-desc-text",
                                                children: model.modelDesc[locale]
                                            })
                                        ]
                                    })
                                ]
                            }, model.modelDesc[locale]),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: i === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "model-box-dv"
                                })
                            })
                        ]
                    }, model.modelName.en[0]);
                })
            })
        ]
    });
};
/* harmony default export */ var Feature_AiModelSelection = (AiModelSelection);
var AiModelSelectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AiModelSelection__AiModelSelectionContainer",
    componentId: "sc-4a8b83eb-0"
})(AiModelSelection_templateObject(), global_styles/* GRAY50 */.mu, global_styles/* GRAY50 */.mu, global_styles/* GRAY90 */.cW, global_styles/* GRAY10 */.Ir, global_styles.BB, global_styles/* BBLight95 */.$k);

;// CONCATENATED MODULE: ./components/Product/ProductFeatures.tsx

function ProductFeatures_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 96px 0 0;\n  .feat-unit-wrapper + .feat-unit-wrapper {\n    margin-top: 96px;\n  }\n  .feat-unit-wrapper:last-child {\n    margin-bottom: 146px;\n  }\n  @media screen and (max-width: 904px) {\n    padding: 56px 0 0;\n    .feat-unit-wrapper + .feat-unit-wrapper {\n      margin-top: 56px;\n    }\n    .feat-unit-wrapper:last-child {\n      margin-bottom: 96px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 32px 0 0;\n    .feat-unit-wrapper:last-child {\n      margin-bottom: 56px;\n    }\n  }\n"
    ]);
    ProductFeatures_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ProductFeatures = function(param) {
    var featureItems = param.featureItems, locale = param.locale, pName = param.pName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductFeaturesContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feat-title-wrapper",
                children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleEn, {
                    children: "Product features"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleKR, {
                    children: "제품 특징"
                })
            }),
            featureItems.featureItems.map(function(featureItem) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "feat-unit-wrapper",
                    children: [
                        featureItem.vids[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemVideoComponent, {
                            videoSrc: featureItem.vids[0],
                            featureTitle: featureItem.featureName[locale],
                            featureDescription: featureItem.featureText[locale]
                        }),
                        featureItem.imgs && featureItem.imgs[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImageComponent, {
                            imageSrcArray: featureItem.imgs.map(function(img) {
                                return img.src;
                            }).filter(Boolean),
                            featureTitle: featureItem.featureName[locale],
                            featureDescription: featureItem.featureText[locale],
                            artDirection: featureItem.artDirection,
                            wrapMedia: featureItem.wrapMedia
                        }),
                        ((!featureItem.imgs || ((ref = featureItem.imgs) === null || ref === void 0 ? void 0 : ref.length) === 0) && (!featureItem.vids || ((ref1 = featureItem.vids) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) || featureItem.customComponent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_ItemCustomComponent, {
                            featureTitle: featureItem.featureName[locale],
                            featureDescription: featureItem.featureText[locale],
                            customComponent: (featureItem === null || featureItem === void 0 ? void 0 : featureItem.customComponent) || null,
                            locale: locale
                        })
                    ]
                }, featureItem.featureName["en"]);
            }),
            pName.toLowerCase().includes("sr") && (featureItems === null || featureItems === void 0 ? void 0 : featureItems.aiModelSelection) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_AiModelSelection, {
                locale: locale,
                aiModelSelection: featureItems.aiModelSelection
            })
        ]
    });
};
/* harmony default export */ var Product_ProductFeatures = (ProductFeatures);
var ProductFeaturesContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ProductFeatures__ProductFeaturesContainer",
    componentId: "sc-58528a93-0"
})(ProductFeatures_templateObject());

;// CONCATENATED MODULE: ./components/Product/ProductDevicesPlatforms.tsx


function ProductDevicesPlatforms_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .feat-title-wrapper {\n        overflow-y: hidden;\n      }\n      .feat-title-wrapper > div {\n        animation: ",
        " 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n        opacity: 1;\n      }\n      .d-p-i {\n        animation: ",
        " 1s 0.6s cubic-bezier(0.4, 0, 0.2, 1)\n          backwards;\n        opacity: 1;\n      }\n      .d-p-t {\n        animation: ",
        " 1s 0.9s cubic-bezier(0.4, 0, 0.2, 1)\n          backwards;\n        opacity: 1;\n      }\n    "
    ]);
    ProductDevicesPlatforms_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductDevicesPlatforms_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 96px 0 146px;\n  .feat-title-wrapper > div {\n    opacity: 0;\n  }\n  .d-p-t,\n  .d-p-i {\n    opacity: 0;\n  }\n  .img-wrapper {\n    width: 100%;\n    display: flex;\n  }\n  .left-wrapper {\n    position: relative;\n    width: 50%;\n    height: 328px;\n    overflow: hidden;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  .d-p-desc {\n    margin-bottom: 32px;\n    color: ",
        ";\n  }\n  .picto-wrapper {\n    position: relative;\n    width: 160px;\n    height: 160px;\n    margin-bottom: 8px;\n  }\n  ",
        ";\n  @media screen and (max-width: 904px) {\n    padding: 56px 0 96px;\n    .img-wrapper {\n      flex-direction: column;\n    }\n    .left-wrapper {\n      width: 100%;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 32px 0 56px;\n    .left-wrapper {\n      height: 280px;\n    }\n  }\n"
    ]);
    ProductDevicesPlatforms_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ProductDevicesPlatforms = function(param) {
    var locale = param.locale, devicesPlatforms = param.devicesPlatforms, devicesPlatformsDesc = param.devicesPlatformsDesc;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDevicesPlatformsContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feat-title-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleEn, {
                        children: "Supported Devices / Supported Platforms"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleKR, {
                        children: "지원 디바이스 / 지원 플랫폼"
                    })
                })
            }),
            devicesPlatformsDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                className: "d-p-desc",
                children: devicesPlatformsDesc[locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "img-wrapper",
                children: devicesPlatforms.map(function(devicePlatform) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "left-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                                style: {
                                    backgroundColor: "#253a50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    sizes: "(min-width: 905px) 40vw, (min-width: 600px) 80vw, (max-width: 599px) 48vw ",
                                    src: devicePlatform.bgImg,
                                    layout: "fill",
                                    alt: "About bluedot",
                                    className: "target-img",
                                    objectFit: "cover",
                                    quality: 60,
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "picto-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    sizes: "160px",
                                    src: devicePlatform.pictogram,
                                    layout: "fill",
                                    alt: "About bluedot",
                                    objectFit: "cover",
                                    quality: 70,
                                    priority: true,
                                    className: "d-p-i"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                                className: "d-p-t",
                                children: devicePlatform.platform[locale]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextM */.OV, {
                                className: "d-p-t",
                                children: devicePlatform.device[locale]
                            })
                        ]
                    }, devicePlatform.bgImg);
                })
            })
        ]
    });
};
/* harmony default export */ var Product_ProductDevicesPlatforms = (/*#__PURE__*/(0,react.memo)(ProductDevicesPlatforms));
var ProductDevicesPlatformsContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ProductDevicesPlatforms__ProductDevicesPlatformsContainer",
    componentId: "sc-a31c85ba-0"
})(ProductDevicesPlatforms_templateObject1(), global_styles/* GRAY30 */.zm, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(ProductDevicesPlatforms_templateObject(), BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn);
});

;// CONCATENATED MODULE: ./components/Product/ProductProvide.tsx


function ProductProvide_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .feat-title-wrapper {\n        animation: ",
        " 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n        opacity: 1;\n      }\n      .provide-box-wrapper {\n        animation: ",
        " 1s 0.3s cubic-bezier(0.4, 0, 0.2, 1)\n          backwards;\n        opacity: 1;\n      }\n    "
    ]);
    ProductProvide_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductProvide_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 96px 0;\n  overflow: hidden;\n  .provide-box-wrapper {\n    margin: 32px 0 32px;\n    display: flex;\n    gap: 56px;\n    flex-wrap: wrap;\n  }\n  .provide-box {\n    flex-shrink: 0;\n    width: calc(50% - 28px);\n    color: ",
        ";\n  }\n  .provide-name {\n    color: ",
        ";\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n  }\n  .dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: ",
        ";\n    display: inline-block;\n    margin-right: 8px;\n  }\n  ",
        ";\n  @media screen and (max-width: 904px) {\n    padding: 56px 0;\n    .provide-box-wrapper {\n      gap: 0;\n    }\n    .provide-box {\n      width: 100%;\n    }\n    .provide-box + .provide-box {\n      margin-top: 32px;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 32px 0;\n  }\n"
    ]);
    ProductProvide_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ProductProvide = function(param) {
    var pName = param.pName, provide = param.provide, locale = param.locale;
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 2), targetRef = ref[0], isVisible = ref[1];
    if (pName.toLowerCase().includes("avif")) return null;
    if (provide.length === 0 && !pName.toLowerCase().includes("avif")) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductProvideContainer, {
        ref: targetRef,
        isVisible: isVisible,
        style: {
            padding: "10px 0"
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductProvideContainer, {
        ref: targetRef,
        isVisible: isVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feat-title-wrapper",
                children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleEn, {
                    children: "How we deliver the product"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleKR, {
                    children: "제품 제공방식"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "provide-box-wrapper",
                children: provide.map(function(p) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "provide-box",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles.H5, {
                                className: "provide-name",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "dot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: p.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextL */.q6, {
                                children: p.text[locale]
                            })
                        ]
                    }, p.name);
                })
            })
        ]
    });
};
/* harmony default export */ var Product_ProductProvide = (ProductProvide);
var ProductProvideContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ProductProvide__ProductProvideContainer",
    componentId: "sc-c88dd181-0"
})(ProductProvide_templateObject1(), global_styles/* GRAY50 */.mu, global_styles/* GRAY10 */.Ir, global_styles/* BBBright */.DS, function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(ProductProvide_templateObject(), BannerItems/* txtAnimation */.Xn, BannerItems/* txtAnimation */.Xn);
});

// EXTERNAL MODULE: ./components/Product/ProductContactUs.tsx
var ProductContactUs = __webpack_require__(9766);
;// CONCATENATED MODULE: ./locale/ProductTemplateButtons.tsx

function ProductTemplateButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 156px;\n  height: 48px;\n"
    ]);
    ProductTemplateButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ButtonsWithTryForFree = function() {
    var locale = (0,router.useRouter)().locale;
    var handleMoveToContactUsPage = (0,useContactModal/* useContactModal */.s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTemplateMainButton, {
                buttonType: "default",
                text: locale === "en" ? "Try For Free" : "체험 해보기",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {}),
                iconPosition: "right",
                tag: "a",
                href: "https://www.kokoon.cloud",
                target: "_blank"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTemplateMainButton, {
                onClick: handleMoveToContactUsPage,
                buttonType: "default",
                text: locale === "en" ? "Contact us" : "제품 문의하기"
            })
        ]
    });
};
var ButtonWithContact = function() {
    var locale = (0,router.useRouter)().locale;
    var handleMoveToContactUsPage = (0,useContactModal/* useContactModal */.s)().handleMoveToContactUsPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTemplateMainButton, {
            onClick: handleMoveToContactUsPage,
            buttonType: "default",
            text: locale === "en" ? "Contact us" : "제품 문의하기"
        })
    });
};
var ProductTemplateButtons = {
    sr: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonsWithTryForFree, {}),
    pqo: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWithContact, {}),
    av1: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWithContact, {}),
    avif: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWithContact, {}),
    vmaf: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWithContact, {})
};
var ProductTemplateMainButton = (0,styled_components_browser_esm/* default */.ZP)(MainButton/* MainButton */.c).withConfig({
    displayName: "ProductTemplateButtons__ProductTemplateMainButton",
    componentId: "sc-6077578a-0"
})(ProductTemplateButtons_templateObject());

// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(6582);
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/web-developer@2x.png
/* harmony default export */ var web_developer_2x = ({"src":"/_next/static/media/web-developer@2x.fbb11804.png","height":240,"width":240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEVMaXEjl9+6vbv////z9/uJzuv//+eDfYlNsN1paGcAAAA+nNKkzOUEitmz0+aHxOnr8PKjo6H7+ffm7fXQ7/hcw5330ehgwqC6vMbhgrfJ5fLAjKzsdLj8/f/0icUrT3GJAAAAHnRSTlMA/oQY+vsLDU6AATnbqN/83oP1+/4v+Jz9Vvxmw/66dvhoAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAQElEQVR4nDXLRwKAMAgEwE0CAWyxd/z/M73o3Af4icU4mAnS6O5OCVp4Il8PtCHQfD436qbrmfcLyFlUtwXV119aRwKUqi4l/QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/web-designer@2x.png
/* harmony default export */ var web_designer_2x = ({"src":"/_next/static/media/web-designer@2x.b1defa74.png","height":240,"width":240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEXJycnC196MjIuvtLiLi4vW4eeotLEpJ0mjsa7S0tLQ192Hpqror2/SnGLVrYOUsavAuLgvUZGyu7Q4XqB6kLWap6k5XZrK2+WtsLQazlPNAAAAF3RSTlMB/LHZwfxLCRf81WNQObgrRVt4r/KJ9nY3AywAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABASURBVHicLctLDoAgDEDBB7SUgop/vP9JjYmrWQ0ApZcPyK0Z05LX/boPZldVPTesjhBGNSy5+5OMEkVE4t+AF0b0Ac/qWlaIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/just-developer@2x.png
/* harmony default export */ var just_developer_2x = ({"src":"/_next/static/media/just-developer@2x.a926989b.png","height":240,"width":240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAUVBMVEVMaXHq4uCBvtFHqNfj7vT4+v7z9v5tg6DV1Oz//Pwpm7wtl9FIpt5YWFVkZGLKyuOyscO4ucz/8e3////w7faDx8q53PBturn/////6eHL6fdwh/1SAAAAGHRSTlMAkBMp9vz5CH0X/jr7S21czK30s47+wtSNytQEAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAP0lEQVR4nB3LRxKAMBDEQDnOmpwx/P+hlDmpLwLAhyC8c8fdDT1le+r5I8YU30uUnHKqO8hsWW1uj6axBSQJPk4sAgp9kp3NAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Product/Pulsar/avifProductProvideContents.ts



var en = [
    {
        img_src: web_developer_2x.src,
        t: "Web Developer",
        t_desc: "Image Conversion API Document",
        desc: "When image conversion is required to speed up the loading of the web/app service screen, or when image optimization and conversion functions are required within the web/app service."
    },
    {
        img_src: web_designer_2x.src,
        t: "Web Designer",
        t_desc: "Image Converting Web・App Service",
        desc: "When you need an image with a small file size while maintaining the high quality of the original image."
    },
    {
        img_src: just_developer_2x.src,
        t: "Developer",
        t_desc: "SDK Installation with Accelerating System",
        desc: "When you need a modular/installable image optimization and transformation development kit that for local server-based applications equipped with FPGA accelerator cards."
    }, 
];
var ko = [
    {
        img_src: web_developer_2x.src,
        t: "웹개발자",
        t_desc: "이미지 변환 API 도큐먼트 제공",
        desc: "웹・앱 서비스 화면의 로딩 속도를 빠르게 하기 위한 이미지 변환이 필요한 경우 또는 웹・앱 서비스 내에서 이미지 최적화 및 변환 기능이 필요한 경우"
    },
    {
        img_src: web_designer_2x.src,
        t: "웹디자이너",
        t_desc: "이미지 변환 웹・앱 서비스 제공",
        desc: "원본의 선명한 화질은 유지하고 작은 용량의 이미지가 필요한 경우"
    },
    {
        img_src: just_developer_2x.src,
        t: "개발자",
        t_desc: "가속 처리 기능이 포함된 설치형 SDK 제공",
        desc: "FPGA 가속 카드가 장착된 로컬 서버 기반의 애플리케이션에 적용할 수 있는 모듈형・설치형 이미지 최적화 및 변환 개발킷이 필요한 경우"
    }, 
];

;// CONCATENATED MODULE: ./components/Product/Pulsar/AvifProductProvide.tsx

function AvifProductProvide_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      .tt {\n        opacity: 1;\n      }\n      .provide-items {\n        opacity: 1;\n      }\n    "
    ]);
    AvifProductProvide_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AvifProductProvide_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 96px 0;\n  overflow: hidden;\n  /* margin-bottom: 192px; */\n  .provide-items {\n    display: flex;\n    width: 100%;\n    padding-top: 20px;\n  }\n  .tt {\n    display: block;\n    margin: 32px 0 24px;\n  }\n  ",
        ";\n  @media screen and (max-width: 1240px) {\n    margin-bottom: 96px;\n  }\n  @media screen and (max-width: 904px) {\n    padding: 56px 0;\n    margin-bottom: 56px;\n    .provide-items {\n      flex-direction: column;\n    }\n  }\n  @media screen and (max-width: 599px) {\n    padding: 32px 0;\n    margin-bottom: 32px;\n  }\n"
    ]);
    AvifProductProvide_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AvifProductProvide_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0%, 100% {\n    transform: scale(1);\n  } 50% {\n    transform: scale(1.2);\n  }\n"
    ]);
    AvifProductProvide_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AvifProductProvide_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 16px 24px;\n\n  &[data-link='true']:hover {\n    text-decoration: underline;\n  }\n\n  &[data-link='true'] .img-wrapper {\n    animation: ",
        " 2s infinite;\n  }\n\n  .img-wrapper {\n    background: ",
        ";\n    border-radius: 50%;\n    width: 168px;\n    height: 168px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .img-inner-wrapper {\n    position: relative;\n    width: 120px;\n    height: 120px;\n  }\n  .img {\n    width: 100%;\n    height: 100%;\n  }\n  .t {\n    margin-top: 20px;\n    color: ",
        ";\n  }\n  .t-desc {\n    color: ",
        ";\n    text-align: center;\n  }\n  svg {\n    margin-left: 8px;\n  }\n  .desc {\n    margin-top: 8px;\n    color: ",
        ";\n  }\n  @media screen and (max-width: 1239px) {\n    padding: 16px 20px;\n  }\n  @media screen and (max-width: 904px) {\n    padding: 16px 80px;\n  }\n  @media screen and (max-width: 599px) {\n    padding: 16px 0;\n  }\n"
    ]);
    AvifProductProvide_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var AvifProductProvide = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var locale = param.locale, isVisible = param.isVisible;
    var provideItems = locale === "en" ? en : ko;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvifProductProvideContainer, {
        ref: ref,
        isVisible: isVisible,
        children: [
            locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubTitleText */.YV, {
                className: "tt",
                children: "How we deliver the product"
            }) : // <ProductCommonTitleEn className="tt">
            //   How we deliver the product
            // </ProductCommonTitleEn>
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleKR, {
                children: "제품 제공방식"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "provide-items",
                children: provideItems.map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvifProductProvideItem, {
                        as: i === 0 ? "a" : "li",
                        href: i === 0 ? "https://avif-documentation.blue-dot.io/documentation/user/verify-user/" : undefined,
                        target: i === 0 ? "_blank" : undefined,
                        "data-link": i === 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "img-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "img-inner-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        quality: 80,
                                        className: "img",
                                        src: item.img_src,
                                        alt: "",
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                                className: "t",
                                children: item.t
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextMStrong */.X9, {
                                className: "t-desc",
                                children: [
                                    item.t_desc,
                                    i === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GoToIcon */.A5, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextM */.OV, {
                                className: "desc",
                                children: item.desc
                            })
                        ]
                    }, item.t);
                })
            })
        ]
    });
});
AvifProductProvide.displayName = "AvifProductProvide";
/* harmony default export */ var Pulsar_AvifProductProvide = (AvifProductProvide);
var AvifProductProvideContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "AvifProductProvide__AvifProductProvideContainer",
    componentId: "sc-2af25a66-0"
})(AvifProductProvide_templateObject1(), function(param) {
    var isVisible = param.isVisible;
    return isVisible && (0,styled_components_browser_esm/* css */.iv)(AvifProductProvide_templateObject());
});
var scaleInfinite = (0,styled_components_browser_esm/* keyframes */.F4)(AvifProductProvide_templateObject2());
var AvifProductProvideItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "AvifProductProvide__AvifProductProvideItem",
    componentId: "sc-2af25a66-1"
})(AvifProductProvide_templateObject3(), scaleInfinite, global_styles/* BBLight95 */.$k, global_styles/* GRAY10 */.Ir, global_styles/* BBBright */.DS, global_styles/* GRAY40 */.vm);

// EXTERNAL MODULE: ./components/Product/Pulsar/AvifSQTestCondition.tsx
var AvifSQTestCondition = __webpack_require__(1222);
;// CONCATENATED MODULE: ./components/Product/Pulsar/AvifProductFeatures.tsx

function AvifProductFeatures_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 96px;\n  .avif-vid-wrapper {\n    width: 100%;\n    position: relative;\n    padding-top: 56.25%;\n  }\n  .avif-vid {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    AvifProductFeatures_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var AvifProductFeatures = function(param) {
    var locale = param.locale, featureItems = param.featureItems;
    var ref = (0,react.useState)(undefined), isMobile = ref[0], setIsMobile = ref[1];
    var setRefs = useAutoPlayVideoWhenVisible();
    // mobile, desktop 비디오 결정
    (0,react.useEffect)(function() {
        if (lib/* isMobileOnly */.UA) setIsMobile(true);
        else setIsMobile(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvifProductFeaturesContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "feat-title-wrapper",
                children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleEn, {
                    children: "Product features"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCommonTitleKR, {
                    children: "제품 특징"
                })
            }),
            featureItems.featureItems.map(function(featureItem) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "feat-unit-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "n-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                                children: featureItem.featureName[locale]
                            })
                        }),
                        isMobile !== undefined && featureItem.vids.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "avif-vid-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                ref: setRefs,
                                src: isMobile ? featureItem.vids[0] : featureItem.vids[1],
                                className: "avif-vid",
                                playsInline: true,
                                controls: true,
                                muted: true,
                                loop: true
                            })
                        }),
                        featureItem.featureText[locale].map(function(t) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextL */.q6, {
                                className: "t",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t
                                })
                            }, t);
                        })
                    ]
                }, featureItem.featureName["en"]);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AvifProductProvide, {
                isVisible: true,
                locale: locale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvifSQTestCondition/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Pulsar_AvifProductFeatures = (AvifProductFeatures);
var AvifProductFeaturesContainer = (0,styled_components_browser_esm/* default */.ZP)(ProductFeaturesContainer).withConfig({
    displayName: "AvifProductFeatures__AvifProductFeaturesContainer",
    componentId: "sc-35100ef5-0"
})(AvifProductFeatures_templateObject());

;// CONCATENATED MODULE: ./public/asset/product/deepfield/01-section-2/01-SR12/SR12-content1-img@2x.png
/* harmony default export */ var SR12_content1_img_2x = ({"src":"/_next/static/media/SR12-content1-img@2x.b06bfcba.png","height":624,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUECBIoSW1OWnIeJi96pLoZM0sLHT+guMUPp+p6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGUlEQVR4nGNgAAEmJjYwzczOwghhsDIyAgABrgAkkXfzngAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/01-section-2/01-SR12/SR12-content2-img@2x.png
/* harmony default export */ var SR12_content2_img_2x = ({"src":"/_next/static/media/SR12-content2-img@2x.c81c4120.png","height":900,"width":1351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEWBhYOOjYqew8q40dche5OHmpyelI6do6KHjo6qnpg8lacvip6tsLF+jZGinJilwsaBe3VVpbfA2uGRwc6avMJcEeNIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAMElEQVR4nAXBiQHAIAgAsVNQwLfV7j9rE8yWleIT3BPwMEZE1Jq4+ctb5KCqvbf2/hnIAT3Gba/QAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/02-section-3/01-SR12/content2/icon-1@2x.png
/* harmony default export */ var icon_1_2x = ({"src":"/_next/static/media/icon-1@2x.62a4466f.png","height":160,"width":160,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEUjIyMpKSkpKS0pKCYpKCYnJCcASqcoKSkpKSsAVtsAQpUqKysAQo0aL0pmLIukAAAADnRSTlMCORNoWh0teE4cVM1zVt/2Da0AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA4SURBVHicJYu5DcAwDMTus/wk2X/dQDALgg0BQGiU2I7AaAwtgl+d95Agd9XumLEzCciP1x1H+wcc+QDQ7cOtvwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/02-section-3/01-SR12/content2/icon-2@2x.png
/* harmony default export */ var icon_2_2x = ({"src":"/_next/static/media/icon-2@2x.ac259e26.png","height":160,"width":160,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEUqKyoqKigqKioBQIgmKy4nKi4oKSonKSoAAABMaXEKP4IARJMpKikpKSktKSQrKCYAPz8ARJwrKBopJyfPRK77AAAAFHRSTlMTLCDOQYRnWQEAUGKt83bVBDRMbuJVXOAAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA7SURBVHicFcEJEsAgCATBQUFYzZ3//zWVblT8hHxkPq+hbLqmO0rWut3gmL3HmVjE8G0PyERtgKSqUn060QGqCXQbAQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/03-section-4/pictogram/pictogram-1@2x.png
/* harmony default export */ var pictogram_1_2x = ({"src":"/_next/static/media/pictogram-1@2x.54aacc15.png","height":320,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEVMZslGi8K2ytCNvto0kM5yq+x2rep1iJpzntVKk8C80dYtaJpkmM2auti00Ng+isGRrMArdqowh8SmzN+g0uy12OZ6osk7g7cVvudOAAAAFXRSTlMBtPn+/jVWKEoN+nDzkdDDl/jv1fbpsisgAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAPUlEQVR4nFXKOxaAIAwAwQUiSfCDguj9b+qjdIupFn7lZbqGGgyw7ZWmwP5cIgZ+jJTGnfEzllj6vFVVnQ8qfQGLb30wuAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/03-section-4/pictogram/pictogram-2@2x.png
/* harmony default export */ var pictogram_2_2x = ({"src":"/_next/static/media/pictogram-2@2x.16e28e3b.png","height":320,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEVlh56BrMhTdLVpgf5Yb81ghM9gdvZbdb85R6BLWsFoks2Inf9KVqFiicxXeJpAUnhCVXY+T3ZXaclvnspwns08z1HbAAAAFXRSTlMCFfxCQvwvCRgqtyRJ3bL4tfhV2/SaFYOsAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAO0lEQVR4nCXGRwLAIAwEsQGM15SEtP+/NQd0EmiwlUFSgD/n+3ULfK5cqzXavHeiXfno5hBKpCJAIPEDODQBgRJEWTIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/03-section-4/bg/section4-bg-1@2x.png
/* harmony default export */ var section4_bg_1_2x = ({"src":"/_next/static/media/section4-bg-1@2x.2e35c337.png","height":685,"width":1260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUVKUUVK0iC/ZrNAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHUlEQVR4nCXIsQ0AMBDEILz/0tF9OgSVMMwfCzk8AXYAEmxXgz8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/03-section-4/bg/section4-bg-2@2x.png
/* harmony default export */ var section4_bg_2_2x = ({"src":"/_next/static/media/section4-bg-2@2x.7219d14b.png","height":685,"width":1260,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUxRVorP1ReIkPoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAD0lEQVR4nGNgwAUYYTQjAAAxAAQQbaGnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/01-section-2/02-SR3/SR3-content1-img@2x.png
/* harmony default export */ var SR3_content1_img_2x = ({"src":"/_next/static/media/SR3-content1-img@2x.b98c4d95.png","height":624,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUXGTAXFiQYGR4dHDkgK0YdJ1QrMjM1KT8E84EaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVR4nGNgYmJkYGBgZmZgYmRkYGBjZwUzmFlYWAECWAA23WorfAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/01-section-2/02-SR3/SR3-content2-img@2x.png
/* harmony default export */ var SR3_content2_img_2x = ({"src":"/_next/static/media/SR3-content2-img@2x.b4493f2b.png","height":900,"width":1351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJ1BMVEUQBw0ABAcpCxcaCBFdFCpDChsqGyoBDxkbFyJBGzF+GTh4N1ajKlG0Be6pAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAKklEQVR4nB3Bhw0AIBADsSP5Qtt/XiRsMDAFlshIEVF5zxZ2a1VNxtf9AAwWAJtMVJgSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/01-section-2/03-PQO/PQO-content1-img@2x.png
/* harmony default export */ var PQO_content1_img_2x = ({"src":"/_next/static/media/PQO-content1-img@2x.2eea49be.png","height":624,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEUJCRUKEyMpJiFwUCxOPSpQKxAnGxurXSBaSC4dMy7LejaLoLCHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVR4nGNgYGBgYGNm5mRgYGBkZGHn4gAzmFhZmAADVABE01sVrQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/asset/product/deepfield/01-section-2/03-PQO/PQO-content2-img@2x.png
/* harmony default export */ var PQO_content2_img_2x = ({"src":"/_next/static/media/PQO-content2-img@2x.b890b158.png","height":900,"width":1351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAOVBMVEVMktlWfqfAl20zf8pDjdVXmt44X4c1fMQ7gslCic5aiLUzhNBuSjRSk9GSjXprXVBXksmeW0xxi6+98+l9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAALUlEQVR4nAXBCQIAEAgAwUWp3Pz/sWZw95TMjJB6cytGUEd+3QHZSyJQ1TNBPhgcAROcT4ecAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/04-AV1/AV1-content1-img@2x.png
/* harmony default export */ var AV1_content1_img_2x = ({"src":"/_next/static/media/AV1-content1-img@2x.91274334.png","height":624,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEUICRUgJ0AMECIQGzhZYndKUmi/vcGReBqZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nGNgYGBgYGJkZgbRDCxsLGAGEyMrIwMAAbYAJP35QhsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/04-AV1/AV1-content2-img@2x.png
/* harmony default export */ var AV1_content2_img_2x = ({"src":"/_next/static/media/AV1-content2-img@2x.411f5d55.png","height":900,"width":1351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAANlBMVEU2SVN0jqhbb3pxfIctNjtRYm0kLDI6T10zPkcjMT0UGiCBgX0wQlYhQ0RIaHhobXVjgYtnbHEjVX4HAAAACXBIWXMAAC4jAAAuIwF4pT92AAAALklEQVR4nAXBiQGAIAwAsSv9QUD3X9aEB5thVqRfFRkJey0Xhzzvh46kq2NG9Q8WAQELell8GgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/04-AV1/AV1-section3-graph1@2x.png
/* harmony default export */ var AV1_section3_graph1_2x = ({"src":"/_next/static/media/AV1-section3-graph1@2x.8c3b4727.png","height":671,"width":1192,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAALVBMVEX09PP9+/jv7+/8+/nV2+Ll6u6yxdjk4+PGyMytwNXNzMvJz9a+y9vKz9SbuM2it1y8AAAAA3RSTlP9+f1BGPAIAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKklEQVR4nB3Bhw0AIAzAsNBJWf+fi8DGUvj6SG2qIDb7tnJ8VUUch/YgFw9VALKaODf7AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/04-AV1/AV1-section3-graph2@2x.png
/* harmony default export */ var AV1_section3_graph2_2x = ({"src":"/_next/static/media/AV1-section3-graph2@2x.4ffa0ecc.png","height":671,"width":1192,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJ1BMVEX9+vj49fPx8fK3yt7j6e/u7ezF1eTm5eXT2N7NzMzIx8fO0tekwduiWad9AAAAAnRSTlP5+5mCvFgAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAoSURBVHicFcGJEQAwCAIwqKD22X/engm6vAbOLtAmfFtSJhTjJYhBfhATAJ1nQPmgAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/AVIF-content1-img@2x.png
/* harmony default export */ var AVIF_content1_img_2x = ({"src":"/_next/static/media/AVIF-content1-img@2x.76ec7126.png","height":624,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEUHCBULFSo3QUQLHzs1NTyFk6EoRGtWZnM3NEBaX2Wyr7yRKH2ZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nGNgYGBgYORgYwbRDJxcrIxgBhM7CwMAAt0AOW8ctR4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/05-AVIF/AVIF-content2-img@2x.png
/* harmony default export */ var AVIF_content2_img_2x = ({"src":"/_next/static/media/AVIF-content2-img@2x.154eaf69.png","height":900,"width":1351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAARVBMVEVzhIJebnK4xtA9SFqbsbd6i4yEkZCKmp12laCNsL2evcZNZnhahIKJoqNne4Gms7lramlydIBeYGdBWWFSbYB9nJ5mj5hO5KiDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAMElEQVR4nAXBhwEAIAgDsKIo4N7/n2oCCq471oooDEnJgCARxwxtzLX1PpD3OWspHxrSAWS+ApILAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/06-VMAF/VMAF-content1-img@2x.png
/* harmony default export */ var VMAF_content1_img_2x = ({"src":"/_next/static/media/VMAF-content1-img@2x.b3ed62b2.png","height":624,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUICRQQFSMNGTA5OEkMIUsmNVEpNmMnLj+53rkoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nGNgYGBgYGZlYQLRDOzMbGAGIyMjIwMAAh8AJbQazOYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/06-VMAF/VMAF-content2-img@2x.png
/* harmony default export */ var VMAF_content2_img_2x = ({"src":"/_next/static/media/VMAF-content2-img@2x.d34bf205.png","height":900,"width":1351,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEUMGTEQID4IEycZLmcXKUvnQEUHAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAI0lEQVR4nB3GwREAIACDMKDuP7OneYVCBSp2fmBDSjdfwCMXBN0AOL5Pc9AAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/06-VMAF/VMAF-section3-graph1-S@2x.png
/* harmony default export */ var VMAF_section3_graph1_S_2x = ({"src":"/_next/static/media/VMAF-section3-graph1-S@2x.c367b204.png","height":657,"width":1201,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEX29vb09PTN2uXZ4ej5+Pjp6uzt8fT9/fy/wcnP0dVYnQrxAAAABHRSTlP99P38YEtSKwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAACZJREFUeJwVxskRADAIA7HlsIH+G85ELwGS1AHc7v04M6uDGdseHgh7AIITAX6hAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/asset/product/pulsar/06-VMAF/VMAF-section3-graph1-XL@2x.png
/* harmony default export */ var VMAF_section3_graph1_XL_2x = ({"src":"/_next/static/media/VMAF-section3-graph1-XL@2x.98c00ca1.png","height":657,"width":2401,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEX09PT39/fU3ubt7/Dl6e7N0tj0+Dq+AAAAAXRSTlP1jTHe9QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABpJREFUeJxjYGRkZmVlZmRgYGZkYWJiZmQAAAFqACSje3JrAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./components/Product/Molcules/Feature/Av1PQOCustomLink.tsx

function Av1PQOCustomLink_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  .pqo-link {\n    color: ",
        ";\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 32px;\n    font-family: 'Noto Sans KR';\n    margin-left: 8px;\n    letter-spacing: -0.01em;\n    text-decoration-line: underline;\n  }\n"
    ]);
    Av1PQOCustomLink_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var featureText = {
    ko: "블루닷의 인지화질 최적화 제품과 연동하여 추가적인 압축 효율 향상이 가능합니다.",
    en: "It is possible to further improve the encoding efficiency by taking advantage of BLUEDOT's AI based Perceptual Quality Optimizer."
};
var label = {
    ko: "PQO 살펴보기",
    en: "See the details of DeepField-PQO"
};
var href = {
    ko: "/product/pqo/#product-section",
    en: "/product/pqo/#product-section"
};
var Av1PQOCustomLink = function(param) {
    var locale = param.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Av1PQOCustomLinkContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextL */.q6, {
            className: "feature-t",
            children: [
                featureText[locale],
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: href[locale],
                    locale: locale,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "pqo-link",
                        children: label[locale]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Feature_Av1PQOCustomLink = (Av1PQOCustomLink);
var Av1PQOCustomLinkContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Av1PQOCustomLink__Av1PQOCustomLinkContainer",
    componentId: "sc-12e1b1d2-0"
})(Av1PQOCustomLink_templateObject(), global_styles/* GRAY50 */.mu, global_styles.SB);

;// CONCATENATED MODULE: ./components/Product/Pulsar/Av1MSU.tsx

function Av1MSU_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .img-wrapper {\n    position: relative;\n    width: 100%;\n    padding-top: 65.25%;\n  }\n  .link-wrapper,\n  .link-wrapper a {\n    color: ",
        " !important;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  .link-wrapper a {\n    text-decoration: underline;\n  }\n"
    ]);
    Av1MSU_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Av1MSU = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Av1MSUContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "img-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                    isNormalUse: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/asset/product/pulsar/04-AV1/msu.png",
                        layout: "fill",
                        alt: "bluedot",
                        className: "banner-img",
                        quality: 70,
                        sizes: "(min-width: 906px) 90vw, (min-width: 600px) 85vw, (max-width: 599px) 75vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextL */.q6, {
                className: "link-wrapper",
                as: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Link: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextL */.q6, {
                        as: "a",
                        href: "https://www.compression.ru/video/codec_comparison/2022/ultrafast_report.html#results",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "https://www.compression.ru/video/codec_comparison/2022/ultrafast_report.html#results"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Pulsar_Av1MSU = (Av1MSU);
var Av1MSUContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Av1MSU__Av1MSUContainer",
    componentId: "sc-23b84146-0"
})(Av1MSU_templateObject(), global_styles/* GRAY50 */.mu);

;// CONCATENATED MODULE: ./locale/productTemplateContents.tsx


var sr1sr2Video1 = __webpack_require__(8557);
var sr1sr2Video2 = __webpack_require__(8114);
var sr1sr2Video3 = __webpack_require__(5189);






// ##### sr3


var sr3Video1 = __webpack_require__(4456);
var sr3Video2 = __webpack_require__(3045);
// ##### pqo


var pqoVideo1 = __webpack_require__(2401);
// ## av1




var av1Video1 = __webpack_require__(434);
// ## avif


var avifPerformanceVideoMobile = __webpack_require__(7357);
var avifPerformanceVideoDesktop = __webpack_require__(545);
// ## vmaf






var pulsarContents = {
    av1: {
        banner: {
            bannerImg: AV1_content1_img_2x,
            bannerTitle: "Pulsar-AV1",
            bannerText: {
                ko: "차세대 동영상 압축 포맷인 AV1 코덱을 반도체 설계 기술로 개발한 고성능 인코더 IP 입니다.",
                en: "A high-performance AV1 encoder, the next generation video codec format, developed using semiconductor design technologies"
            }
        },
        productDescription: {
            productDescriptionImg: AV1_content2_img_2x,
            productTitle: {
                ko: [
                    "기존 코덱보다 적은 데이터로",
                    "더 많은 비디오를 지원"
                ],
                en: [
                    "Supports more videos with less data than traditional codecs"
                ]
            },
            productText: {
                ko: [
                    "증가하는 동영상 트래픽에 따른 데이터 저장 및 송출 비용 상승에 대한 부담이 커지고 있습니다. 압축효율이 높은 차세대 코덱 표준인 AV1이 기존 H.264의 대안이 되고 있습니다. 그러나 소프트웨어 기반의 코덱은 높은 연산량 때문에 추가적인 컴퓨팅 비용 상승이 불가피하여 코덱 교체가 쉽지 않습니다.",
                    "블루닷은 반도체 설계 기술로 AV1 인코딩의 속도를 높이고 비용을 절감하였습니다.", 
                ],
                en: [
                    "Due to an increase in video traffic, expenses associated with data storage and network are rising. AV1, the next-generation codec standard with high compression efficiency, is becoming an alternative to the existing H.264. However, due to high computational load, software-based AV1 encoder requires further computational cost increases, making codec replacement difficult.",
                    "BLUEDOT leverages semiconductor design technology to accelerate and lower the cost of AV1 encoding.", 
                ]
            }
        },
        productFeatures: {
            featureItems: [
                {
                    featureName: {
                        ko: "Pulsar-AV1 인코더 IP 성능",
                        en: "Pulsar-AV1 encoder performance"
                    },
                    featureText: {
                        ko: [
                            "AV1 반도체 인코더 IP는 FPGA(e.g. 자일링스 알베오 U250, U55c 카드) 기반으로 가속되며 저지연 인코딩에 적합합니다.",
                            "CPU 기반의 svt-av1 대비 6배 이상의 빠른 속도로 인코딩을 할 수 있으며 높은 압축 성능을 보입니다.", 
                        ],
                        en: [
                            "AV1 encoder is FPGA-accelerated and suitable for low-latency encoding. Compared to CPU-based svt-av1, encoding performs at a 6x faster speed and shows higher compression efficiency.", 
                        ]
                    },
                    vids: [],
                    imgs: [
                        AV1_section3_graph1_2x,
                        AV1_section3_graph2_2x
                    ],
                    wrapMedia: true
                },
                {
                    featureName: {
                        ko: "nVIDIA, Intel, AMD보다 크게 앞서고 글로벌 벤치마크에서 검증된 압축률",
                        en: "Top 3 best video encoder in MSU Hardware Video Codec Comparison"
                    },
                    featureText: {
                        ko: "",
                        en: ""
                    },
                    imgs: [],
                    vids: [],
                    customComponent: Pulsar_Av1MSU
                },
                {
                    featureName: {
                        ko: "Pulsar-AV1 인코더 IP 화질",
                        en: "Quality of Pulsar-AV1 encoder IP"
                    },
                    featureText: {
                        ko: [],
                        en: []
                    },
                    vids: [
                        av1Video1
                    ],
                    mobileVids: [
                        av1Video1
                    ]
                },
                {
                    featureName: {
                        ko: "Pulsar-AV1 인코더 비트 전송률 효율성",
                        en: "Pulsar-AV1 encoder bitrate efficiency"
                    },
                    featureText: {
                        // ko: [
                        //   '블루닷의 인지화질 최적화 제품과 연동하여 추가적인 압축 효율 향상이 가능합니다.',
                        // ],
                        // en: [
                        //   "It is possible to further improve the encoding efficiency by taking advantage of BLUEDOT's AI based Perceptual Quality Optimizer.",
                        // ],
                        ko: [],
                        en: []
                    },
                    vids: [],
                    customComponent: Feature_Av1PQOCustomLink,
                    link: {
                        label: {
                            ko: "PQO 살펴보기",
                            en: "See the details of DeepField-PQO"
                        },
                        href: {
                            ko: "/product/pqo/#product-section",
                            en: "/product/pqo/#product-section"
                        }
                    }
                }, 
            ]
        },
        devicesPlatforms: [
            {
                platform: {
                    ko: "온프레미스",
                    en: "On premise"
                },
                device: {
                    ko: "자일링스 알베오 U250 카드",
                    en: "XILINX ALVEO U250 CARD"
                },
                bgImg: section4_bg_1_2x.src,
                pictogram: pictogram_2_2x.src
            },
            {
                platform: {
                    ko: "클라우드",
                    en: "Cloud"
                },
                device: {
                    ko: "MS Azure NP 인스턴스",
                    en: "MS AZURE NP Instance"
                },
                bgImg: section4_bg_2_2x.src,
                pictogram: pictogram_1_2x.src
            }, 
        ],
        devicesPlatformsDesc: {
            ko: "자일링스 FPGA 디바이스에 최적화 하였으며 반도체 IP로 구현되었습니다.",
            en: "Pulsar-AV1 is implemented into Silicon IP optimal for AMD/Xilinx FPGAs."
        },
        productProvide: [
            {
                name: "SDK",
                text: {
                    ko: "FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.",
                    en: "Provided as an SDK optimized for FPGA accelerator cards and as it runs under FFmpeg framework, making it simple to integrate into your media workflow."
                }
            },
            {
                name: "Silicon IP",
                text: {
                    ko: "블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.",
                    en: "The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance."
                }
            }, 
        ]
    },
    avif: {
        banner: {
            bannerImg: AVIF_content1_img_2x,
            bannerTitle: "Pulsar-AVIF",
            bannerText: {
                ko: "JPEG 대비 화질의 열화없이 50% 이하의 파일 크기로 압축할 수 있는 반도체 설계 기술 기반의 고성능 AVIF 이미지 인코더 입니다.",
                en: "It is a high-performance AVIF image encoder developed leveraging semiconductor design technology that reduces file size by 50% or less without sacrificing quality as compared to JPEG."
            }
        },
        productDescription: {
            productDescriptionImg: AVIF_content2_img_2x,
            productTitle: {
                ko: [
                    "사진의 용량과 네트워크",
                    "사용을 반으로"
                ],
                en: [
                    "Cut storage and",
                    "network usage in half"
                ]
            },
            productText: {
                ko: [
                    "웹페이지 데이터의 50% 이상이 이미지로 구성되어 있으며 고화질.고해상도 사진의 사용 선호가 높아지고 있습니다. 늘어가는 이미지의 비중은 이커머스 웹페이지의 로딩 시간을 느리게 하고 네트워크 비용 상승의 원인이 됩니다.",
                    "JPEG 이미지 압축 코덱을 대신할 수 있는 AVIF 인코더는 높은 연산량으로 인한 느린 속도가 문제입니다.",
                    "블루닷은 반도체 설계 기술을 이용하여 매우 빠른 이미지 압축이 가능한 AVIF 인코더 IP를 개발하였습니다.", 
                ],
                en: [
                    "Images make up more than half of web page data, and the preference for high-quality, high-resolution images is booming. The increasing usage of images in online pages delays loading times and raises network expenses.",
                    "The AVIF encoder, which is the next generation codec for replacing JPEG, has a slow performance issue due to a high computation complexity.",
                    "BLUEDOT provides an FPGA-accelerated AVIF encoder capable of extremely fast image compression that is developed using semiconductor design technologies.", 
                ]
            }
        },
        productFeatures: {
            featureItems: [
                {
                    featureName: {
                        ko: "AVIF 지원 운영체제 및 브라우저 증가",
                        en: "A growing number of AVIF-compliant operating systems and browsers"
                    },
                    featureText: {
                        ko: [
                            "윈도우10와 안드로이드 12 운영체제 그리고 크롬, 파이어폭스등의 주요 웹브라우저에서 지원되고 있습니다. 그리고 최근 iOS16에서 AVIF 지원 발표로 사파리에서도 사용이 가능해짐에 따라 현존하는 대부분의 웹브라우저에서 AVIF 이미지 파일을 오픈할 수 있게 되었습니다.", 
                        ],
                        en: [
                            "Windows 10 and Android 12 operating systems, as well as major web browsers such as Chrome, and Firefox, all support AVIF format. With the recent addition of AVIF format compatibility in iOS16 and Safari, AVIF image files may now be opened in the majority of existing web browsers.", 
                        ]
                    },
                    vids: []
                },
                {
                    featureName: {
                        ko: "Pulsar-AVIF 인코더 IP 성능",
                        en: "Pulsar-AVIF encoder performance"
                    },
                    featureText: {
                        ko: [
                            "AVIF 반도체 인코더 IP는 FPGA(e.g. 자일링스 알베오 U250, U55c 카드) 기반으로 가속됩니다. CPU를 사용하는 소프트웨어 AVIF 인코더와 비교하여 21배 빠르게 인코딩 할 수 있습니다.", 
                        ],
                        en: [
                            "AVIF encoder is FPGA(e.g AMD/Xilinx Alveo U250, U55C card) accelerated and performs 21 times faster than the CPU-based AVIF encoder.", 
                        ]
                    },
                    artDirection: true,
                    imgs: [],
                    vids: [
                        avifPerformanceVideoMobile,
                        avifPerformanceVideoDesktop
                    ]
                }, 
            ]
        },
        devicesPlatforms: [
            {
                platform: {
                    ko: "온프레미스",
                    en: "On premise"
                },
                device: {
                    ko: "자일링스 알베오 카드",
                    en: "Xilinx ALVEO Card"
                },
                bgImg: section4_bg_1_2x.src,
                pictogram: pictogram_2_2x.src
            },
            {
                platform: {
                    ko: "클라우드",
                    en: "Cloud"
                },
                device: {
                    ko: "MS Azure NP 시리즈 인스턴스",
                    en: "MS Azure NP-Series Instances"
                },
                bgImg: section4_bg_2_2x.src,
                pictogram: pictogram_1_2x.src
            }, 
        ],
        devicesPlatformsDesc: {
            ko: "AVIF 인코더는 반도체 IP로 구현되었습니다.",
            en: "Pulsar-AV1 is implemented into Silicon IP optimal for AMD/Xilinx FPGAs."
        },
        productProvide: [
            {
                name: "SDK",
                text: {
                    ko: "FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.",
                    en: "Provided as an SDK optimized for FPGA accelerator cards and as it runs under FFmpeg framework, making it simple to integrate into your media workflow."
                }
            },
            {
                name: "Silicon IP",
                text: {
                    ko: "블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.",
                    en: "The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance."
                }
            }, 
        ]
    },
    vmaf: {
        banner: {
            bannerImg: VMAF_content1_img_2x,
            bannerTitle: "Pulsar-VMAF",
            bannerText: {
                ko: "오픈소스보다 빠르게 VMAF 품질 평가 알고리즘을 가속하여 영상의 품질을 측정합니다.",
                en: "It measures VMAF, a video quality metric, faster than open source."
            }
        },
        productDescription: {
            productDescriptionImg: VMAF_content2_img_2x,
            productTitle: {
                ko: [
                    "매우 빠른",
                    "VMAF 가속기"
                ],
                en: [
                    "Very fast",
                    "VMAF accelerator"
                ]
            },
            productText: {
                ko: [
                    "영상의 품질을 인간의 주관적(지각적) 수준으로 평가 해야할 필요성이 높아졌습니다. 넷플릭스가 공개한 VMAF가 널리 사용되고 있으나 높은 연산량으로 컴퓨팅 비용과 처리 시간에 대한 부담이 발생합니다.",
                    "블루닷은 반도체 설계 기술을 이용하여 VMAF 전용 가속 IP로 구현하였기 때문에 비용 부담을 줄일 수 있습니다.", 
                ],
                en: [
                    "There is an increasing need to measure video quality on a human subjective (perceptual) level. Although Netflix's VMAF is extensively used, its large computational load places a strain on computer expenses and processing time.",
                    "BLUEDOT lowers the cost burden since it develops a VMAF-specific accelerator using semiconductor design techniques.", 
                ]
            }
        },
        productFeatures: {
            featureItems: [
                {
                    featureName: {
                        ko: "늘어가는 VMAF 적용 서비스",
                        en: "VMAF becoming widely used metric"
                    },
                    featureText: {
                        ko: [
                            "사업자는 동영상별(per-title) 가장 최적화된 (비트율, 해상) 조합을 찾아서 서비스함으로써 저장.전송 비용 절감과 동시에 사용자의 시청 경험을 향상시키려고 합니다.", 
                        ],
                        en: [
                            "Service Providers try to find the optimal combination(bit rate, resolution) for each video or shot so as to save storage and network costs while improving the user's viewing experience. Encoding and VMAF quality measuring must be done dozens of times to find the optimal combination, which necessitates a significant amount of computation resources. By leveraging BLUEDOT's semiconductor design technology, you can speed up VMAF quality measurements and reduce computing costs.", 
                        ]
                    },
                    vids: [],
                    imgs: []
                },
                {
                    featureName: {
                        ko: "Pulsar-VMAF 성능",
                        en: "Pulsar-VMAF Performance"
                    },
                    featureText: {
                        ko: [
                            "블루닷의 VMAF 반도체 IP는 FPGA 기반으로 가속됩니다. CPU 기반의 오픈 소스보다 x4 빠른 VMAF 품질 측정이 가능하고 컴퓨팅 비용이 x3 절감 됩니다.", 
                        ],
                        en: [
                            "FPGA-accelerated VMAF is x4 faster than CPU-based open source and x3 lower in compute costs.", 
                        ]
                    },
                    artDirection: true,
                    vids: [],
                    imgs: [
                        VMAF_section3_graph1_XL_2x,
                        VMAF_section3_graph1_S_2x
                    ]
                }, 
            ]
        },
        devicesPlatforms: [
            {
                platform: {
                    ko: "온프레미스",
                    en: "On premises"
                },
                device: {
                    ko: "자일링스 알베오 U50, U55c 카드",
                    en: "Xilinx ALVEO U50, U55c CARD"
                },
                bgImg: section4_bg_1_2x.src,
                pictogram: pictogram_2_2x.src
            },
            {
                platform: {
                    ko: "클라우드",
                    en: "Cloud"
                },
                device: {
                    ko: "MS Azure NP 인스턴스, AWS EC2 f1 인스턴스",
                    en: "MS Azure NP10 instances, AWS EC2 f1 instances"
                },
                bgImg: section4_bg_2_2x.src,
                pictogram: pictogram_1_2x.src
            }, 
        ],
        devicesPlatformsDesc: {
            ko: "인공지능 모델의 경량화를 통해 지원 디바이스에 최적화 하였으며 반도체 IP로 구현되었습니다.",
            en: "Pulsar-VMAF is implemented into Silicon IP optimal for AMD/Xilinx FPGAs."
        },
        productProvide: [
            {
                name: "SDK",
                text: {
                    ko: "FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.",
                    en: "Provided as an SDK optimized for FPGA accelerator cards and as it runs under FFmpeg framework, making it simple to integrate into your media workflow."
                }
            },
            {
                name: "Silicon IP",
                text: {
                    ko: "블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.",
                    en: "The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance."
                }
            }, 
        ]
    }
};
var deepfieldContents = {
    sr: {
        banner: {
            bannerImg: SR12_content1_img_2x,
            bannerTitle: "DeepField-SR",
            bannerText: {
                ko: "인공지능 기반의 초해상화 기술로써 동영상의 시・공간적 정보를 활용하여 고화질 및 고해상도의 영상으로 변환합니다.",
                en: "It is an AI-powered Super Resolution technology that upscales videos to high resolution and improves video quality by using temporal and spatial information."
            }
        },
        productDescription: {
            productDescriptionImg: SR12_content2_img_2x,
            productTitle: {
                ko: [
                    "디테일을 살린 또렷한",
                    "화질개선 솔루션"
                ],
                en: [
                    "Eliminate encoding",
                    "noise and artifacts"
                ]
            },
            productText: {
                ko: [
                    "슈퍼레졸루션은 노이즈 제거, 영상 화질 향상, 그리고 업스케일링등의 영상 처리 알고리즘들로 구성되어 있습니다.",
                    "각각의 알고리즘들을 위한 뉴럴 네트워크 모델은 저화질.저해상도 입력 영상으로부터 고화질.고해상도의 우수한 품질의 영상을 예측할 수 있도록 수 많은 비디오 데이터세트로 학습됩니다.",
                    "연속된 비디오 프레임들간의 시간적 정보를 활용하여 더 자연스럽고 향상된 화질의 영상으로 생성합니다.", 
                ],
                en: [
                    "Video SR consists of video processing algorithms such as noise removal, image quality enhancement, and upscaling.",
                    "For each algorithm, Neural Network model is trained on a large number of video For each algorithm, Neural Network model is trained on a large number of video",
                    "It makes advantage of the temporal information from multiple video frames to provide a more realistic and better visual quality.", 
                ]
            }
        },
        productFeatures: {
            aiModelSelection: {
                briefText: {
                    ko: "동영상 서비스 목적에 따라 최적화된 두 가지 다른 모델을 제공합니다.",
                    en: "We provide two separate AI models that are tailored to serve various video service needs."
                },
                modelItems: [
                    {
                        modelPictoImg: icon_1_2x.src,
                        modelName: {
                            ko: [
                                "성능 모델"
                            ],
                            en: [
                                "Performance focused model"
                            ]
                        },
                        modelDesc: {
                            ko: "최고의 성능으로 라이브 스트리밍에 적용해야 하는 경우",
                            en: "Applied for a live streaming with the highest level of performance"
                        }
                    },
                    {
                        modelPictoImg: icon_2_2x.src,
                        modelName: {
                            ko: [
                                "품질 모델"
                            ],
                            en: [
                                "Quality focused model"
                            ]
                        },
                        modelDesc: {
                            ko: "최상의 품질로 고해상도 업스케일링해야 하는 경우",
                            en: "Applied for better enhancement quality and upscaling resolution"
                        }
                    }, 
                ]
            },
            featureItems: [
                {
                    featureName: {
                        ko: "인코딩 노이즈 및 아티팩트 제거",
                        en: "Remove encoding noise and artifact"
                    },
                    featureText: {
                        ko: [
                            "노이즈 및 아티팩트 제거 알고리즘의 학습으로 동영상 손실 압축시 발생하는 인코딩 아티팩트(블럭킹)를 제거하고 디테일을 보존합니다.", 
                        ],
                        en: [
                            "The trained Neural Network for the noise and artifacts removing algorithm removes encoding artifacts (blocking) that occur during video lossy compression and preserves details.", 
                        ]
                    },
                    mobileVids: [
                        sr1sr2Video1
                    ],
                    vids: [
                        sr1sr2Video1
                    ]
                },
                {
                    featureName: {
                        ko: "영상 화질 향상 및 업스케일링",
                        en: "Enhancing video quality and upscaling video resolution"
                    },
                    featureText: {
                        ko: [
                            "학습된 인공지능 모델이 섬세한 텍스쳐를 추가 하고 선명도를 향상시켜 고해상도의 영상으로 생성합니다.", 
                        ],
                        en: [
                            "The trained AI model enhances clarity and adds delicate textures to produce high quality videos.", 
                        ]
                    },
                    mobileVids: [
                        sr1sr2Video2
                    ],
                    vids: [
                        sr1sr2Video2
                    ]
                },
                {
                    featureName: {
                        ko: "동영상의 시간적 정보 활용",
                        en: "Use the temporal information from video"
                    },
                    featureText: {
                        ko: [
                            "연속된 비디오의 프레임들간 정보를 활용하여 싱글 프레임 기반의 초해상화 기술에서 발생하는 모션 블러나 떨림 효과를 크게 줄였습니다.", 
                        ],
                        en: [
                            "The motion blur that typically arises in single-frame-based upscaling has been significantly minimized by combining temporal information from many frames.", 
                        ]
                    },
                    mobileVids: [
                        sr1sr2Video3
                    ],
                    vids: [
                        sr1sr2Video3
                    ]
                }, 
            ]
        },
        devicesPlatformsDesc: {
            ko: "인공지능 모델의 경량화를 통해 지원 디바이스에 최적화 하였으며 소프트웨어 그리고 반도체 IP로 구현되었습니다.",
            en: "A light-weighted AI model implemented into software and semiconductor IP that is designed for supported devices"
        },
        devicesPlatforms: [
            {
                platform: {
                    ko: "온프레미스",
                    en: "On premises"
                },
                device: {
                    ko: "엔비디아 GPU 카드, 자일링스 알베오 FPGA 카드",
                    en: "Nvidia GPU Card, Xilinx ALVEO FPGA Card"
                },
                bgImg: section4_bg_1_2x.src,
                pictogram: pictogram_2_2x.src
            },
            {
                platform: {
                    ko: "클라우드",
                    en: "Cloud"
                },
                device: {
                    ko: "AWS EC2 인스턴스, MS Azure NP 인스턴스",
                    en: "AWS EC2 instances, MS Azure NP instances"
                },
                bgImg: section4_bg_2_2x.src,
                pictogram: pictogram_1_2x.src
            }, 
        ],
        productProvide: [
            {
                name: "SDK",
                text: {
                    ko: "GPU/FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.",
                    en: "Provided as an SDK optimized for GPU/FPGA accelerator cards and supports the FFmpeg framework, making it simple to integrate into your media workflow."
                }
            },
            {
                name: "Silicon IP",
                text: {
                    ko: "블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.",
                    en: "DeepField products are also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance."
                }
            },
            {
                name: "UI Service",
                text: {
                    ko: "서비스 사업자를 위한 파일 기반의 영상 변환 클라우드 서비스를 제공합니다.",
                    en: "Offers file-based video upscaling cloud service for content providers"
                }
            }, 
        ]
    },
    // ################################################################ sr3 ################################################################
    sr3: {
        banner: {
            bannerImg: SR3_content1_img_2x,
            bannerTitle: "DeepField-SR3",
            bannerText: {
                ko: "컴퓨터 비전의 성능을 높이기 위해 화질이 개선된 영상 데이터 입력을 제공합니다.",
                en: "Improve better and more effective visual data input, which boosts computer vision performance."
            }
        },
        productDescription: {
            productDescriptionImg: SR3_content2_img_2x,
            productTitle: {
                ko: [
                    "화질 개선으로 컴퓨터 비전",
                    "시스템의 효율을 향상"
                ],
                en: [
                    "Enhancing image quality improves",
                    "the efficiency of computer vision systems", 
                ]
            },
            productText: {
                ko: [
                    "영상내 정보의 해석 가능성 또는 정보 인식의 확률을 높이기 위해 화질 개선이 필요합니다.",
                    "블루닷의 인공지능 모델은 조도를 개선하고 노이즈를 절감할 수 있도록 수 많은 이미지, 비디오 데이터셋으로 학습되었습니다.",
                    "특히, 의미 있는 객체를 분류하는 영상 분석 기술 그리고 문서 이미지내에서의 텍스트 또는 차량 번호판 등의 인식 기술에 도움이 되는 화질 개선에 특화되어 있습니다.", 
                ],
                en: [
                    "It is required to enhance video quality to boost the interpretability of information or the probability of recognition in video.",
                    "BLUEDOT's proprietary AI model is trained on various image and video datasets to improve low light and remove noise.",
                    "It specializes in video analysis technology to identify relevant objects and video quality enhancement to support text or license plate recognition.", 
                ]
            }
        },
        productFeatures: {
            featureItems: [
                {
                    featureName: {
                        ko: "조도 개선",
                        en: "Low light image enhancement"
                    },
                    featureText: {
                        ko: [
                            "어두운 환경에서 촬영된 영상을 개선하여 객체에 대한 정보 식별의 비율을 높일 수 있습니다.", 
                        ],
                        en: [
                            "By making improvements of light to the video taken in a dark environment, object detection may increase.", 
                        ]
                    },
                    mobileVids: [
                        sr3Video1
                    ],
                    vids: [
                        sr3Video1
                    ]
                },
                {
                    featureName: {
                        ko: "이미지 내 텍스트 선명도 개선",
                        en: "Text sharpness improvement"
                    },
                    featureText: {
                        ko: [
                            "이미지내의 품질 낮은 텍스트 선명도를 개선하여 문자 인식률과 정확도를 높일 수 있습니다.", 
                        ],
                        en: [
                            "Sharpening the poor-quality text in the image will improve text recognition accuracy.", 
                        ]
                    },
                    mobileVids: [
                        sr3Video2
                    ],
                    vids: [
                        sr3Video2
                    ]
                }, 
            ]
        },
        devicesPlatformsDesc: {
            ko: "인공지능 모델의 경량화를 통해 지원 디바이스에 최적화 하였으며 소프트웨어 그리고 반도체 IP로 구현되었습니다.",
            en: "A light-weighted AI model implemented into software and semiconductor IP that is designed for supported devices"
        },
        devicesPlatforms: [
            {
                platform: {
                    ko: "온프레미스",
                    en: "On premises"
                },
                device: {
                    ko: "엔비디아 GPU 카드, AMD/자일링스 알베오 FPGA 카드",
                    en: "NVidia GPU Card, AMD/Xilinx Alveo FPGA Card"
                },
                bgImg: section4_bg_1_2x.src,
                pictogram: pictogram_2_2x.src
            },
            {
                platform: {
                    ko: "클라우드",
                    en: "Cloud"
                },
                device: {
                    ko: "AWS EC2 인스턴스, MS Azure NP 인스턴스",
                    en: "AWS EC2 Instance, MS Azure NP Instance"
                },
                bgImg: section4_bg_2_2x.src,
                pictogram: pictogram_1_2x.src
            }, 
        ],
        productProvide: [
            {
                name: "SDK",
                text: {
                    ko: "GPU 서버에 성능 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.",
                    en: "Provided as an SDK optimized for GPU/FPGA accelerator cards and supports the FFmpeg framework, making it simple to integrate into your media workflow."
                }
            },
            {
                name: "UI Service",
                text: {
                    ko: "서비스 사업자를 위한 파일 기반의 영상 변환 클라우드 서비스를 제공합니다.",
                    en: "Offers file-based video upscaling cloud service for content providers."
                }
            }, 
        ]
    },
    // ################################################################ pqo ################################################################
    pqo: {
        banner: {
            bannerImg: PQO_content1_img_2x,
            bannerTitle: "DeepField-PQO",
            bannerText: {
                ko: "인공지능 기술로 입력 영상을 전처리하여 영상의 화질은 유지하면서 코덱의 압축 효율을 높입니다.",
                en: "AI technology is used to preprocess the input video in order to increase the compression efficiency of the codec while preserving video quality."
            }
        },
        productDescription: {
            productDescriptionImg: PQO_content2_img_2x,
            productTitle: {
                ko: [
                    "비디오 픽셀을 최적화하여",
                    "인코딩 효율을 향상"
                ],
                en: [
                    "Optimize video pixels",
                    "to improve encoding efficiency"
                ]
            },
            productText: {
                ko: [
                    "시청자가 인지하는 화질의 열화가 없지만 영상 압축 성능이 향상될 수 있도록 인코딩 과정의 특성을 고려하여 학습된 인공지능 모델입니다.",
                    "어떠한 코덱(codec agnostic)과도 함께 사용할 수 있으며 압축 효율을 최대화 합니다.",
                    "컴퓨팅 인프라 비용의 상승등을 이유로 차세대 압축 코덱으로 교체가 어려운 경우, 사용중인 코덱에 적용할 수 있으며 평균 30%의 영상 저장 및 송출 비용을 줄일 수 있습니다.", 
                ],
                en: [
                    "It is an artificial intelligence model trained in consideration of the encoding process so that there is no perceived quality degradation by viewers, but video compression efficiency can be improved.",
                    "It works with any codec and improves compression efficiency.",
                    "If replacing with the next-generation compression codec is impractical owing to increased computing infrastructure costs, it can be applied to the existing codec, lowering the cost of storage and network by 30% on average.", 
                ]
            }
        },
        productFeatures: {
            featureItems: [
                {
                    featureName: {
                        ko: "인지화질 최적화",
                        en: "Perceptual video quality optimization"
                    },
                    featureText: {
                        ko: [
                            "학습된 인공지능 모델로 인간의 인지 화질에 영향을 주는 부분의 디테일을 향상 시키고 중요하지 않은 부분의 디테일을 줄여 고화질 영상 압축에 필요한 데이터 사용량을 절감합니다. 인지적 화질의 열화 없이 고품질의 영상 압축에 필요한 데이터 사용량을 절감합니다.", 
                        ],
                        en: [
                            "The pretrained AI model enhances the details of areas that affect human perception quality while decreasing the details of minor areas. It reduces the amount of data required for video compression while maintaining perceptual video quality.", 
                        ]
                    },
                    mobileVids: [
                        pqoVideo1
                    ],
                    vids: [
                        pqoVideo1
                    ]
                }, 
            ]
        },
        devicesPlatforms: [
            {
                platform: {
                    ko: "온프레미스",
                    en: "On premises"
                },
                device: {
                    ko: "엔비디아 GPU 카드, 자일링스 알베오 FPGA 카드",
                    en: "Nvidia GPU Card, Xilinx ALVEO FPGA Card"
                },
                bgImg: section4_bg_1_2x.src,
                pictogram: pictogram_2_2x.src
            },
            {
                platform: {
                    ko: "클라우드",
                    en: "Cloud"
                },
                device: {
                    ko: "AWS EC2 인스턴스, MS Azure NP 인스턴스",
                    en: "AWS EC2 instances, MS Azure NP instances"
                },
                bgImg: section4_bg_2_2x.src,
                pictogram: pictogram_1_2x.src
            }, 
        ],
        productProvide: [
            {
                name: "SDK",
                text: {
                    ko: "GPU/FPGA 서버에 성능 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.",
                    en: "Provided as an SDK optimized for GPU/FPGA accelerator cards and supports the FFmpeg framework, making it simple to integrate into your media workflow."
                }
            },
            {
                name: "Silicon IP",
                text: {
                    ko: "블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.",
                    en: "The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance."
                }
            },
            {
                name: "UI Service",
                text: {
                    ko: "서비스 사업자를 위한 파일 기반의 영상 변환 클라우드 서비스를 제공합니다.",
                    en: "Offers file-based video upscaling cloud service for content providers."
                }
            }, 
        ]
    }
};

;// CONCATENATED MODULE: ./components/Product/ProductSectionTabTemplate.tsx


function ProductSectionTabTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  height: 100%;\n\n  .product-name {\n    margin-top: 146px;\n    margin-bottom: 16px;\n    animation: ",
        " 1s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n  }\n  .rep-product-text {\n    color: ",
        ";\n    max-width: 1200px;\n    text-align: center;\n    animation: ",
        " 1s 0.5s cubic-bezier(0.4, 0, 0.2, 1) backwards;\n  }\n  .floating-space-wrapper {\n    height: 72px;\n    @media screen and (min-width: 905px) {\n      height: 60px;\n    }\n    @media screen and (max-width: 904px) and (min-width: 600px) {\n      height: 52px;\n    }\n    @media screen and (max-width: 599px) {\n      height: 44px;\n    }\n  }\n  .layout-container {\n    ",
        ";\n    max-width: 1200px;\n  }\n  .product-wrapper {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding-right: 16px;\n    padding-left: 16px;\n    padding-bottom: 96px;\n  }\n  @media screen and (max-width: 1239px) {\n    .product-name {\n      margin-top: 96px;\n    }\n    .product-wrapper {\n      padding-bottom: 56px;\n    }\n  }\n  @media screen and (max-width: 904px) {\n    .product-name {\n      margin-top: 56px;\n    }\n    .product-wrapper {\n      padding-bottom: 32px;\n    }\n  }\n"
    ]);
    ProductSectionTabTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var ProductSectionTabTemplate = function(param) {
    var productName = param.productName, productDescription = param.productDescription, tabItems = param.tabItems, isMainVisualHidden = param.isMainVisualHidden, pName = param.pName;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var locale = (0,router.useRouter)().locale;
    var renderInformation = (0,react.useMemo)(function() {
        return productName === "DeepField" ? deepfieldContents[pName] : pulsarContents[pName];
    }, [
        pName,
        productName
    ]);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true,
        threshold: 0,
        rootMargin: "-72px"
    }), 3), targetRef = ref6[0], isVisible = ref6[1], entry = ref6[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductSectionTabTemplateContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-wrapper",
                ref: targetRef,
                id: "product-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H2, {
                        as: "h3",
                        className: "product-name",
                        children: productName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                        className: "rep-product-text",
                        children: locale === "en" ? productDescription[1] : productDescription[0]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductTabMenu, {
                isFloatTab:  true && !isVisible && !!(entry === null || entry === void 0 ? void 0 : entry.target) && isMainVisualHidden,
                tabItems: tabItems
            }),
             true && !isVisible && !!(entry === null || entry === void 0 ? void 0 : entry.target) && isMainVisualHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "floating-space-wrapper"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductBanner, {
                bannerImg: renderInformation === null || renderInformation === void 0 ? void 0 : (ref = renderInformation.banner) === null || ref === void 0 ? void 0 : ref.bannerImg.src,
                bannerText: renderInformation === null || renderInformation === void 0 ? void 0 : (ref1 = renderInformation.banner) === null || ref1 === void 0 ? void 0 : ref1.bannerText[locale],
                bannerTitle: renderInformation === null || renderInformation === void 0 ? void 0 : (ref2 = renderInformation.banner) === null || ref2 === void 0 ? void 0 : ref2.bannerTitle,
                buttonText: locale === "en" ? "Contact" : "제품 문의하기"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "layout-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductDescription, {
                        img: renderInformation === null || renderInformation === void 0 ? void 0 : (ref3 = renderInformation.productDescription) === null || ref3 === void 0 ? void 0 : ref3.productDescriptionImg.src,
                        descriptionTitle: renderInformation === null || renderInformation === void 0 ? void 0 : (ref4 = renderInformation.productDescription) === null || ref4 === void 0 ? void 0 : ref4.productTitle[locale],
                        descriptions: renderInformation === null || renderInformation === void 0 ? void 0 : (ref5 = renderInformation.productDescription) === null || ref5 === void 0 ? void 0 : ref5.productText[locale],
                        buttons: ProductTemplateButtons[pName]
                    }),
                    !pName.toLowerCase().includes("avif") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductFeatures, {
                        pName: pName,
                        locale: locale,
                        featureItems: renderInformation === null || renderInformation === void 0 ? void 0 : renderInformation.productFeatures
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulsar_AvifProductFeatures, {
                        locale: locale,
                        featureItems: renderInformation === null || renderInformation === void 0 ? void 0 : renderInformation.productFeatures
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductProvide, {
                        pName: pName,
                        locale: locale,
                        provide: renderInformation === null || renderInformation === void 0 ? void 0 : renderInformation.productProvide
                    }),
                    !pName.toLowerCase().includes("avif") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductDevicesPlatforms, {
                        locale: locale,
                        devicesPlatformsDesc: renderInformation === null || renderInformation === void 0 ? void 0 : renderInformation.devicesPlatformsDesc,
                        devicesPlatforms: renderInformation === null || renderInformation === void 0 ? void 0 : renderInformation.devicesPlatforms
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContactUs/* default */.Z, {
                locale: locale
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Product_ProductSectionTabTemplate = (/*#__PURE__*/(0,react.memo)(ProductSectionTabTemplate));
var ProductSectionTabTemplateContainer = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "ProductSectionTabTemplate__ProductSectionTabTemplateContainer",
    componentId: "sc-b5457958-0"
})(ProductSectionTabTemplate_templateObject(), BannerItems/* txtAnimation */.Xn, global_styles/* GRAY60 */.Ts, BannerItems/* txtAnimation */.Xn, Layout/* gridSystemMargin */.nR);

// EXTERNAL MODULE: ../../node_modules/seamless-scroll-polyfill/lib/scroll.js + 1 modules
var lib_scroll = __webpack_require__(5378);
// EXTERNAL MODULE: ../../node_modules/seamless-scroll-polyfill/lib/common.js
var common = __webpack_require__(6944);
;// CONCATENATED MODULE: ../../node_modules/seamless-scroll-polyfill/lib/scrollIntoView.js
/* eslint-disable no-bitwise */


// https://drafts.csswg.org/css-writing-modes-4/#block-flow
const normalizeWritingMode = (writingMode) => {
    switch (writingMode) {
        case "horizontal-tb":
        case "lr":
        case "lr-tb":
        case "rl":
        case "rl-tb":
            return 0 /* HorizontalTb */;
        case "vertical-rl":
        case "tb":
        case "tb-rl":
            return 1 /* VerticalRl */;
        case "vertical-lr":
        case "tb-lr":
            return 2 /* VerticalLr */;
        case "sideways-rl":
            return 3 /* SidewaysRl */;
        case "sideways-lr":
            return 4 /* SidewaysLr */;
    }
    return 0 /* HorizontalTb */;
};
const calcPhysicalAxis = (writingMode, isLTR, hPos, vPos) => {
    /**  0b{vertical}{horizontal}  0: normal, 1: reverse */
    let layout = 0b00;
    /**
     * WritingMode.VerticalLr: ↓→
     * | 1 | 4 |   |
     * | 2 | 5 |   |
     * | 3 |   |   |
     *
     * RTL: ↑→
     * | 3 |   |   |
     * | 2 | 5 |   |
     * | 1 | 4 |   |
     */
    if (!isLTR) {
        layout ^= 2 /* ReverseVertical */;
    }
    switch (writingMode) {
        /**
         * ↓→
         * | 1 | 2 | 3 |
         * | 4 | 5 |   |
         * |   |   |   |
         *
         * RTL: ↓←
         * | 3 | 2 | 1 |
         * |   | 5 | 4 |
         * |   |   |   |
         */
        case 0 /* HorizontalTb */:
            // swap horizontal and vertical
            layout = (layout >> 1) | ((layout & 1) << 1);
            [hPos, vPos] = [vPos, hPos];
            break;
        /**
         * ↓←
         * |   | 4 | 1 |
         * |   | 5 | 2 |
         * |   |   | 3 |
         *
         * RTL: ↑←
         * |   |   | 3 |
         * |   | 5 | 2 |
         * |   | 4 | 1 |
         */
        case 1 /* VerticalRl */:
        case 3 /* SidewaysRl */:
            //  reverse horizontal
            layout ^= 1 /* ReverseHorizontal */;
            break;
        /**
         * ↑→
         * | 3 |   |   |
         * | 2 | 5 |   |
         * | 1 | 4 |   |
         *
         * RTL: ↓→
         * | 1 | 4 |   |
         * | 2 | 5 |   |
         * | 3 |   |   |
         */
        case 4 /* SidewaysLr */:
            // reverse vertical
            layout ^= 2 /* ReverseVertical */;
            break;
    }
    return [layout, hPos, vPos];
};
const isXReversed = (computedStyle) => {
    const layout = calcPhysicalAxis(normalizeWritingMode(computedStyle.writingMode), computedStyle.direction !== "rtl", undefined, undefined)[0];
    return (layout & 1) === 1;
};
// https://source.chromium.org/chromium/chromium/src/+/main:third_party/blink/renderer/core/dom/element.cc;l=1097-1189;drc=6a7533d4a1e9f2372223a9d912a9e53a6fa35ae0
const toPhysicalAlignment = (options, writingMode, isLTR) => {
    const [layout, hPos, vPos] = calcPhysicalAxis(writingMode, isLTR, options.block || "start", options.inline || "nearest");
    return [hPos, vPos].map((value, index) => {
        switch (value) {
            case "center":
                return 1 /* CenterAlways */;
            case "nearest":
                return 0 /* ToEdgeIfNeeded */;
            default: {
                const reverse = (layout >> index) & 1;
                return (value === "start") === !reverse ? 2 /* LeftOrTop */ : 3 /* RightOrBottom */;
            }
        }
    });
};
// code from stipsan/compute-scroll-into-view
// https://github.com/stipsan/compute-scroll-into-view/blob/5396c6b78af5d0bbce11a7c4e93cc3146546fcd3/src/index.ts
/**
 * Find out which edge to align against when logical scroll position is "nearest"
 * Interesting fact: "nearest" works similarily to "if-needed", if the element is fully visible it will not scroll it
 *
 * Legends:
 * ┌────────┐ ┏ ━ ━ ━ ┓
 * │ target │   frame
 * └────────┘ ┗ ━ ━ ━ ┛
 */
const mapNearest = (align, scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, elementEdgeStart, elementEdgeEnd, elementSize) => {
    if (align !== 0 /* ToEdgeIfNeeded */) {
        return align;
    }
    /**
     * If element edge A and element edge B are both outside scrolling box edge A and scrolling box edge B
     *
     *          ┌──┐
     *        ┏━│━━│━┓
     *          │  │
     *        ┃ │  │ ┃        do nothing
     *          │  │
     *        ┗━│━━│━┛
     *          └──┘
     *
     *  If element edge C and element edge D are both outside scrolling box edge C and scrolling box edge D
     *
     *    ┏ ━ ━ ━ ━ ┓
     *   ┌───────────┐
     *   │┃         ┃│        do nothing
     *   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd) ||
        (elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd)) {
        return null;
    }
    /**
     * If element edge A is outside scrolling box edge A and element height is less than scrolling box height
     *
     *          ┌──┐
     *        ┏━│━━│━┓         ┏━┌━━┐━┓
     *          └──┘             │  │
     *  from  ┃      ┃     to  ┃ └──┘ ┃
     *
     *        ┗━ ━━ ━┛         ┗━ ━━ ━┛
     *
     * If element edge B is outside scrolling box edge B and element height is greater than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━┌━━┐━┓
     *                           │  │
     *  from  ┃ ┌──┐ ┃     to  ┃ │  │ ┃
     *          │  │             │  │
     *        ┗━│━━│━┛         ┗━│━━│━┛
     *          │  │             └──┘
     *          │  │
     *          └──┘
     *
     * If element edge C is outside scrolling box edge C and element width is less than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───┐                 ┌───┐
     *  │ ┃ │       ┃         ┃   │     ┃
     *  └───┘                 └───┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is greater than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *        ┌───────────┐   ┌───────────┐
     *    ┃   │     ┃     │   ┃         ┃ │
     *        └───────────┘   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize) ||
        (elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize)) {
        return 2 /* LeftOrTop */;
    }
    /**
     * If element edge B is outside scrolling box edge B and element height is less than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━ ━━ ━┓
     *
     *  from  ┃      ┃     to  ┃ ┌──┐ ┃
     *          ┌──┐             │  │
     *        ┗━│━━│━┛         ┗━└━━┘━┛
     *          └──┘
     *
     * If element edge A is outside scrolling box edge A and element height is greater than scrolling box height
     *
     *          ┌──┐
     *          │  │
     *          │  │             ┌──┐
     *        ┏━│━━│━┓         ┏━│━━│━┓
     *          │  │             │  │
     *  from  ┃ └──┘ ┃     to  ┃ │  │ ┃
     *                           │  │
     *        ┗━ ━━ ━┛         ┗━└━━┘━┛
     *
     * If element edge C is outside scrolling box edge C and element width is greater than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───────────┐           ┌───────────┐
     *  │     ┃     │   ┃       │ ┃         ┃
     *  └───────────┘           └───────────┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is less than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *                ┌───┐             ┌───┐
     *        ┃       │ ┃ │       ┃     │   ┃
     *                └───┘             └───┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     */
    if ((elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize) ||
        (elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize)) {
        return 3 /* RightOrBottom */;
    }
    return null;
};
const canOverflow = (overflow) => {
    return overflow !== "visible" && overflow !== "clip";
};
const getFrameElement = (element) => {
    var _a;
    try {
        return ((_a = element.ownerDocument.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement) || null;
    }
    catch (_b) {
        return null;
    }
};
const isScrollable = (element, computedStyle) => {
    if (element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth) {
        return (canOverflow(computedStyle.overflowY) ||
            canOverflow(computedStyle.overflowX) ||
            element === (0,common/* scrollingElement */.H0)(element));
    }
    return false;
};
const parentElement = (element) => {
    const pNode = element.parentNode;
    const pElement = element.parentElement;
    if (pElement === null && pNode !== null) {
        if (pNode.nodeType === /** Node.DOCUMENT_FRAGMENT_NODE */ 11) {
            return pNode.host;
        }
        if (pNode.nodeType === /** Node.DOCUMENT_NODE */ 9) {
            return getFrameElement(element);
        }
    }
    return pElement;
};
const clamp = (value, min, max) => {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
const getSupportedScrollMarginProperty = (ownerDocument) => {
    // Webkit uses "scroll-snap-margin" https://bugs.webkit.org/show_bug.cgi?id=189265.
    return ["scroll-margin", "scroll-snap-margin"].filter((property) => property in ownerDocument.documentElement.style)[0];
};
const getElementScrollSnapArea = (element, elementRect, computedStyle) => {
    const { top, right, bottom, left } = elementRect;
    const scrollProperty = getSupportedScrollMarginProperty(element.ownerDocument);
    if (!scrollProperty) {
        return [top, right, bottom, left];
    }
    const scrollMarginValue = (edge) => {
        const value = computedStyle.getPropertyValue(`${scrollProperty}-${edge}`);
        return parseInt(value, 10) || 0;
    };
    return [
        top - scrollMarginValue("top"),
        right + scrollMarginValue("right"),
        bottom + scrollMarginValue("bottom"),
        left - scrollMarginValue("left"),
    ];
};
const calcAlignEdge = (align, start, end) => {
    switch (align) {
        case 1 /* CenterAlways */:
            return (start + end) / 2;
        case 3 /* RightOrBottom */:
            return end;
        case 2 /* LeftOrTop */:
        case 0 /* ToEdgeIfNeeded */:
            return start;
    }
};
const getFrameViewport = (frame, frameRect) => {
    var _a, _b, _c;
    const visualViewport = (_a = frame.ownerDocument.defaultView) === null || _a === void 0 ? void 0 : _a.visualViewport;
    const [x, y, width, height] = frame === (0,common/* scrollingElement */.H0)(frame)
        ? [0, 0, (_b = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _b !== void 0 ? _b : frame.clientWidth, (_c = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _c !== void 0 ? _c : frame.clientHeight]
        : [frameRect.left, frameRect.top, frame.clientWidth, frame.clientHeight];
    const left = x + frame.clientLeft;
    const top = y + frame.clientTop;
    const right = left + width;
    const bottom = top + height;
    return [top, right, bottom, left];
};
const computeScrollIntoView = (element, options) => {
    // Collect all the scrolling boxes, as defined in the spec: https://drafts.csswg.org/cssom-view/#scrolling-box
    const actions = [];
    let ownerDocument = element.ownerDocument;
    let ownerWindow = ownerDocument.defaultView;
    if (!ownerWindow) {
        return actions;
    }
    const computedStyle = window.getComputedStyle(element);
    const isLTR = computedStyle.direction !== "rtl";
    const writingMode = normalizeWritingMode(computedStyle.writingMode ||
        computedStyle.getPropertyValue("-webkit-writing-mode") ||
        computedStyle.getPropertyValue("-ms-writing-mode"));
    const [alignH, alignV] = toPhysicalAlignment(options, writingMode, isLTR);
    let [top, right, bottom, left] = getElementScrollSnapArea(element, element.getBoundingClientRect(), computedStyle);
    for (let frame = parentElement(element); frame !== null; frame = parentElement(frame)) {
        if (ownerDocument !== frame.ownerDocument) {
            ownerDocument = frame.ownerDocument;
            ownerWindow = ownerDocument.defaultView;
            if (!ownerWindow) {
                break;
            }
            const { left: dX, top: dY } = frame.getBoundingClientRect();
            top += dY;
            right += dX;
            bottom += dY;
            left += dX;
        }
        const frameStyle = ownerWindow.getComputedStyle(frame);
        if (frameStyle.position === "fixed") {
            break;
        }
        if (!isScrollable(frame, frameStyle)) {
            continue;
        }
        const frameRect = frame.getBoundingClientRect();
        const [frameTop, frameRight, frameBottom, frameLeft] = getFrameViewport(frame, frameRect);
        const eAlignH = mapNearest(alignH, frameLeft, frameRight, frame.clientWidth, left, right, right - left);
        const eAlignV = mapNearest(alignV, frameTop, frameBottom, frame.clientHeight, top, bottom, bottom - top);
        const diffX = eAlignH === null ? 0 : calcAlignEdge(eAlignH, left, right) - calcAlignEdge(eAlignH, frameLeft, frameRight);
        const diffY = eAlignV === null ? 0 : calcAlignEdge(eAlignV, top, bottom) - calcAlignEdge(eAlignV, frameTop, frameBottom);
        const moveX = isXReversed(frameStyle)
            ? clamp(diffX, -frame.scrollWidth + frame.clientWidth - frame.scrollLeft, -frame.scrollLeft)
            : clamp(diffX, -frame.scrollLeft, frame.scrollWidth - frame.clientWidth - frame.scrollLeft);
        const moveY = clamp(diffY, -frame.scrollTop, frame.scrollHeight - frame.clientHeight - frame.scrollTop);
        actions.push([
            frame,
            { left: frame.scrollLeft + moveX, top: frame.scrollTop + moveY, behavior: options.behavior },
        ]);
        top = Math.max(top - moveY, frameTop);
        right = Math.min(right - moveX, frameRight);
        bottom = Math.min(bottom - moveY, frameBottom);
        left = Math.max(left - moveX, frameLeft);
    }
    return actions;
};
const scrollIntoView = (element, scrollIntoViewOptions, config) => {
    const options = scrollIntoViewOptions || {};
    if (!(0,common/* checkBehavior */.VL)(options.behavior)) {
        throw new TypeError((0,common/* failedExecuteInvalidEnumValue */._L)("scrollIntoView", "Element", options.behavior));
    }
    const actions = computeScrollIntoView(element, options);
    actions.forEach(([frame, scrollToOptions]) => {
        (0,lib_scroll/* elementScroll */.sA)(frame, scrollToOptions, config);
    });
};
const elementScrollIntoView = (/* unused pure expression or super */ null && (scrollIntoView));
//# sourceMappingURL=scrollIntoView.js.map
;// CONCATENATED MODULE: ./utils.ts

var handleScrollToHash = function() {
    var hash = window.location.hash;
    if (hash) {
        var $target = document.querySelector(hash);
        if (hash === "#avif-comparison" && $target) {
            var ref = $target.getBoundingClientRect(), top = ref.top, height = ref.height;
            var HEADER_HEIGHT = 60;
            var TAB_HEIGHT = 62;
            if (window.matchMedia("(max-width: 904px)").matches) {
                HEADER_HEIGHT = 52;
            }
            if (window.matchMedia("(max-width: 599px)").matches) {
                HEADER_HEIGHT = 44;
            }
            var scrollHeight = top + height - (HEADER_HEIGHT + TAB_HEIGHT);
            (0,lib_scroll/* scrollTo */.X5)(window, {
                top: scrollHeight,
                behavior: "smooth"
            });
            return;
        }
        if ($target) scrollIntoView($target, {
            behavior: "smooth"
        });
    }
};

;// CONCATENATED MODULE: ./hooks/useForbidScroll.ts


var useForbidScroll = function() {
    var isPrivatePolicyModalOpen = (0,useContactModal/* usePrivatePolicyModal */.p)().isPrivatePolicyModalOpen;
    var isContactModalOpen = (0,useContactModal/* useContactModal */.s)().isContactModalOpen;
    (0,react.useEffect)(function() {
        if (isPrivatePolicyModalOpen || isContactModalOpen) document.body.style.overflowY = "hidden";
        else document.body.style.overflowY = "unset";
    }, [
        isPrivatePolicyModalOpen,
        isContactModalOpen
    ]);
};

// EXTERNAL MODULE: ./hooks/useRemoveScrollTop.ts
var useRemoveScrollTop = __webpack_require__(8722);
;// CONCATENATED MODULE: ./pages/product/[p_name].tsx


function _p_name_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _p_name_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var deepfieldPathNames = [
    "sr",
    "pqo"
];
var productDescription = [
    "인공지능 기반의 초해상화 기술로써 동영상의 시.공간적 정보를 활용하여 고화질 및 고해상도의 영상으로 변환합니다.",
    "It is an AI-powered Super Resolution technology that upscales videos to high resolution and improves video quality by using temporal and spatial information.", 
];
var productItems = [
    {
        label: "DeepField-SR",
        pathname: "/product/sr"
    },
    {
        label: "DeepField-PQO",
        pathname: "/product/pqo"
    },
    {
        label: "Pulsar-AV1",
        pathname: "/product/av1"
    },
    {
        label: "Pulsar-AVIF",
        pathname: "/product/avif"
    },
    {
        label: "Pulsar-VMAF",
        pathname: "/product/vmaf"
    }, 
];
var DeepfieldPage = function(param) {
    var pName = param.pName;
    var ref = (0,router.useRouter)(), asPath = ref.asPath, locale = ref.locale;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 3), $fakeHeaderRef = ref1[0], isVisible = ref1[1], fakeHeaderEntry = ref1[2];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 3), $mainVisualRef = ref2[0], isVisibleMainVisual = ref2[1], mainVisualEntry = ref2[2];
    var productName = deepfieldPathNames.includes(pName) ? "DeepField" : "Pulsar";
    var contents = deepfieldPathNames.includes(pName) ? deepfieldContents : pulsarContents;
    var productTabItems = productItems.filter(function(item) {
        return item.label.includes(productName);
    });
    (0,useDisablePinchZoomIn/* useDisablePinchZoom */.D)();
    (0,useSetScreenSize/* useSetScreenSize */.K)();
    useForbidScroll();
    (0,useRemoveScrollTop/* useRemoveScrollTop */.W)();
    (0,react.useEffect)(function() {
        handleScrollToHash();
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeepfieldPageContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            contents[pName].banner.bannerTitle,
                            " - BLUEDOT"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: contents[pName].banner.bannerText[locale]
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: contents[pName].banner.bannerText[locale]
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: contents[pName].banner.bannerText[locale]
                    }, "twitter:description")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* BypassBlock */.ok, {
                contentSectionId: "#product-content1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "io-target",
                ref: $fakeHeaderRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader/* default */.Z, {
                isScrolled: !isVisible && !!(fakeHeaderEntry === null || fakeHeaderEntry === void 0 ? void 0 : fakeHeaderEntry.target)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_DeepfieldMainVisual, {
                ref: $mainVisualRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Product_ProductSectionTabTemplate, {
                productName: productName,
                productDescription: productDescription,
                tabItems: productTabItems,
                isMainVisualHidden:  false ? 0 : !isVisibleMainVisual && !!(mainVisualEntry === null || mainVisualEntry === void 0 ? void 0 : mainVisualEntry.target),
                pName: pName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingController/* default */.Z, {
                isVisible: isVisible
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _p_name_ = (DeepfieldPage);
var DeepfieldPageContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* PageOuterContainer */.px).withConfig({
    displayName: "[p_name]__DeepfieldPageContainer",
    componentId: "sc-34351c6a-0"
})(_p_name_templateObject());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [779,965,572,833,774,888,179], function() { return __webpack_exec__(4564); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);